/* v29 — sold stones become a sourcing request, not a dead end.
   "Notify me" used to only flip a label on the page; nobody received anything. Now it opens WhatsApp
   with the stone's details filled in, so the team gets a real lead. Price shows as "Sold at" for an anchor. */
(function(){if(window.__gmSold)return;window.__gmSold=1;var D=document,WA='919217846751';
var css='html body #gmv2.gm-sold .price b::before{content:"Listed price ";font-family:Jost,sans-serif;font-size:13px;letter-spacing:.12em;text-transform:uppercase;color:#5E5E66;vertical-align:middle;margin-right:6px}';
var s=D.createElement('style');s.id='gm-v29';s.textContent=css;D.head.appendChild(s);
function txt(sel){var e=D.querySelector(sel);return e?e.textContent.replace(/\s+/g,' ').trim():''}
function msg(){var t=txt('#gmv2 h1')||document.title,p=txt('#gmv2 .price b'),sp=txt('#gmv2 .spec'),sku=(location.pathname.match(/-(gm\d+|[a-z]{2,4}\d+)$/i)||[])[1]||'';
 return 'Hi, '+(sku?sku.toUpperCase()+' ':'')+'('+t+') is currently unavailable in this selection. Please help me find an available option: '+sp+(p?', listed price '+p:'')+'. '+location.origin+location.pathname}
D.addEventListener('click',function(e){var b=e.target.closest&&e.target.closest('#gmv2 [data-n], .gmv2-sticky button');if(!b)return;
 var g=D.getElementById('gmv2');if(!g||!g.classList.contains('gm-sold'))return;
 window.open('https://wa.me/'+WA+'?text='+encodeURIComponent(msg()),'_blank','noopener')},true);
function relabel(){var g=D.getElementById('gmv2');if(!g||!g.classList.contains('gm-sold'))return;
 [].slice.call(D.querySelectorAll('#gmv2 [data-n], .gmv2-sticky button')).forEach(function(b){var t=b.textContent;
  if(/^NOTIFY ME ABOUT A SIMILAR/i.test(t))b.textContent='FIND ME A STONE LIKE THIS';
  else if(/^NOTIFY ME$/i.test(t.trim()))b.textContent='FIND SIMILAR';
  else if(/ON THE LIST/i.test(t))b.textContent='OPEN WHATSAPP AGAIN'});
 [].slice.call(D.querySelectorAll('#gmv2 .sub')).forEach(function(x){if(/We will WhatsApp you when a matching stone arrives/.test(x.textContent))x.textContent='WhatsApp opens with your request. Send it there to contact a specialist.';
  else if(/^Or choose one of the closest stones below/.test(x.textContent))x.textContent='Our specialist finds a matching stone on WhatsApp. Or pick one of the closest stones below, in stock today.'})}
var q=0;new MutationObserver(function(){if(q)return;q=1;setTimeout(function(){q=0;relabel()},30)}).observe(D.documentElement,{childList:true,subtree:true,characterData:true});
relabel();})();
;
/* GM Studio — puts every gemstone photo on the same studio plinth: same backdrop, same size, same shadow.
   Runs in the browser on same-origin Shopify CDN images. Never edits the product images in Shopify. */
window.GMStudio=(function(){
const OUT=1200;                       /* output square */
/* One studio for every stone: neutral warm grey, same light, same shadow. The plinth is lightest under deep, saturated stones and gains a soft pool of shade under pale ones (pearl, opal, white sapphire), so every edge reads. The tone family never changes, so a grid of mixed stones still looks like one shoot. */
const BG_EDGE=[232,230,225],BG_DEEP=[241,240,236],BG_PALE=[204,202,196];
const cache=new Map();
const load=u=>new Promise((res,rej)=>{const i=new Image();i.crossOrigin='anonymous';i.decoding='async';i.onload=()=>res(i);i.onerror=()=>rej(new Error('load '+u));i.src=u});
const sized=(u,w)=>u.replace(/([?&])width=\d+/,'$1').replace(/[?&]$/,'')+(u.includes('?')?'&':'?')+'width='+w;
function plinth(x,t,O){O=O||OUT;t=Math.max(0,Math.min(1,t||0));const c=BG_DEEP.map((v,i)=>Math.round(v+(BG_PALE[i]-v)*t));const g=x.createRadialGradient(O/2,O*0.47,O*0.04,O/2,O*0.49,O*0.46);g.addColorStop(0,'rgb('+c+')');g.addColorStop(1,'rgb('+BG_EDGE+')');x.fillStyle=g;x.fillRect(0,0,O,O)}
/* segmentation (outline + background colour) — runs on a reduced copy of the photo */
const seg=new Function('d','W','H',`
 const N=W*H,lum=new Float32Array(N),sat=new Float32Array(N);
 for(let i=0;i<N;i++){const r=d[i*4],g=d[i*4+1],b=d[i*4+2];const mx=Math.max(r,g,b),mn=Math.min(r,g,b);lum[i]=(r*299+g*587+b*114)/1000;sat[i]=mx?(mx-mn)/mx:0}
 const bs=[];const pick=(x,y)=>{const k=(y*W+x)*4;bs.push([d[k],d[k+1],d[k+2]])};
 for(let x=0;x<W;x+=Math.max(1,W>>5)){pick(x,0);pick(x,H-1)}for(let y=0;y<H;y+=Math.max(1,H>>5)){pick(0,y);pick(W-1,y)}
 const med=[0,1,2].map(c=>{const a=bs.map(p=>p[c]).sort((p,q)=>p-q);return a[a.length>>1]});
 let sd=0;for(const p of bs)sd+=Math.max(Math.abs(p[0]-med[0]),Math.abs(p[1]-med[1]),Math.abs(p[2]-med[2]));sd/=bs.length;
 const bl=(med[0]*299+med[1]*587+med[2]*114)/1000;
 const tol=16+Math.min(30,sd*2.5);
 const dist=i=>Math.max(Math.abs(d[i*4]-med[0]),Math.abs(d[i*4+1]-med[1]),Math.abs(d[i*4+2]-med[2]));
 /* shadow-like: grey, a bit darker than a light background */
 const shadow=i=>bl>90&&sat[i]<0.10&&lum[i]<bl&&lum[i]>bl*0.42;
 const darkBg=bl<60;const refl=i=>darkBg&&lum[i]<bl+45&&sat[i]<0.6;
 const bgLike=i=>dist(i)<tol||shadow(i)||refl(i);
 const bg=new Uint8Array(N),q=new Int32Array(N);let h=0,t=0;
 const push=i=>{if(!bg[i]&&bgLike(i)){bg[i]=1;q[t++]=i}};
 for(let x=0;x<W;x++){push(x);push((H-1)*W+x)}for(let y=0;y<H;y++){push(y*W);push(y*W+W-1)}
 while(h<t){const i=q[h++],x=i%W;if(x>0)push(i-1);if(x<W-1)push(i+1);if(i>=W)push(i-W);if(i<N-W)push(i+W)}
 /* keep the largest blob (drops watermarks, logos, specks) */
 {const lab=new Int32Array(N);let nl=0;const sz=[0],bb=[null];const qq=new Int32Array(N);
  for(let s0=0;s0<N;s0++){if(bg[s0]||lab[s0])continue;nl++;let hh=0,tt=0;qq[tt++]=s0;lab[s0]=nl;let c=0,ax=W,ay=H,bx=0,by=0;
   while(hh<tt){const i=qq[hh++];c++;const x=i%W,y=(i/W)|0;if(x<ax)ax=x;if(x>bx)bx=x;if(y<ay)ay=y;if(y>by)by=y;
    const nb=[x>0?i-1:-1,x<W-1?i+1:-1,i>=W?i-W:-1,i<N-W?i+W:-1];for(const j of nb){if(j>=0&&!bg[j]&&!lab[j]){lab[j]=nl;qq[tt++]=j}}}
   sz.push(c);bb.push([ax,ay,bx,by])}
  let best=0;for(let k=1;k<=nl;k++)if(!best||sz[k]>sz[best])best=k;
  if(best){const B=bb[best],mx=(B[2]-B[0])*0.08,my=(B[3]-B[1])*0.08;const keep=new Uint8Array(nl+1);
   for(let k=1;k<=nl;k++){const b=bb[k];keep[k]=k===best||(sz[k]>sz[best]*0.002&&b[0]>=B[0]-mx&&b[2]<=B[2]+mx&&b[1]>=B[1]-my&&b[3]<=B[3]+my)?1:0}
   for(let i=0;i<N;i++)if(!bg[i]&&!keep[lab[i]])bg[i]=1}}
 /* cut mirror reflections: rows in the lower part whose colour suddenly fades or darkens */
 {let ya=H,yb=-1;for(let i=0;i<N;i++)if(!bg[i]){const y=(i/W)|0;if(y<ya)ya=y;if(y>yb)yb=y}
  if(yb>ya+10){const RL=new Float32Array(H),RS=new Float32Array(H),RC=new Int32Array(H);
   for(let i=0;i<N;i++)if(!bg[i]){const y=(i/W)|0;RL[y]+=lum[i];RS[y]+=sat[i];RC[y]++}
   for(let y=ya;y<=yb;y++)if(RC[y]){RL[y]/=RC[y];RS[y]/=RC[y]}
   const hgt=yb-ya,top=[];for(let y=ya+Math.round(hgt*0.15);y<=ya+Math.round(hgt*0.55);y++)if(RC[y])top.push([RL[y],RS[y],RC[y]]);
   if(top.length>4){const md=k=>{const a=top.map(t=>t[k]).sort((p,q)=>p-q);return a[a.length>>1]};const rl=md(0),rs=md(1),rc=Math.max(...top.map(t=>t[2]));
    let cut=-1;for(let y=ya+Math.round(hgt*0.55);y<=yb-2;y++){const f=y2=>RC[y2]&&(RL[y2]<rl*0.55||(rs>0.18&&RS[y2]<rs*0.45)||(RC[y2]>RC[y2-1]*1.15&&RC[y2-1]<rc*0.75));if(f(y)&&f(y+1)&&f(y+2)){let mxb=0;for(let y3=y+1;y3<=yb;y3++)if(RC[y3]>mxb)mxb=RC[y3];if(mxb>RC[y]*1.12){cut=y;break}}}
    if(cut>0)for(let i=cut*W;i<N;i++)bg[i]=1}}}
 let cnt=0;const rows=new Int32Array(H),cols=new Int32Array(W);
 for(let i=0;i<N;i++)if(!bg[i]){cnt++;rows[(i/W)|0]++;cols[i%W]++}
 const fr=cnt/N;
 const thR=Math.max(1,W*0.004),thC=Math.max(1,H*0.004);
 let y0=0,y1=H-1,x0=0,x1=W-1;while(y0<H&&rows[y0]<thR)y0++;while(y1>0&&rows[y1]<thR)y1--;while(x0<W&&cols[x0]<thC)x0++;while(x1>0&&cols[x1]<thC)x1--;
 const edgeTouch=(y0<=1)+(y1>=H-2)+(x0<=1)+(x1>=W-2);
 /* alpha: soft edge only where foreground meets background */
 const a=new Uint8ClampedArray(N);
 for(let i=0;i<N;i++){if(bg[i]){a[i]=0;continue}const x=i%W;const nb=(x>0&&bg[i-1])||(x<W-1&&bg[i+1])||(i>=W&&bg[i-W])||(i<N-W&&bg[i+W]);a[i]=nb?Math.max(60,Math.min(255,(dist(i)-tol*0.5)/(tol*1.2)*255)):255}
 /* dark backgrounds leave a dark rim: erode one pixel and soften the next ring */
 if(bl<90){const e=new Uint8Array(N);for(let i=0;i<N;i++){if(!a[i])continue;const x=i%W;if((x>0&&!a[i-1])||(x<W-1&&!a[i+1])||(i>=W&&!a[i-W])||(i<N-W&&!a[i+W]))e[i]=1}for(let i=0;i<N;i++)if(e[i])a[i]=0;for(let i=0;i<N;i++){if(!a[i])continue;const x=i%W;if((x>0&&!a[i-1])||(x<W-1&&!a[i+1])||(i>=W&&!a[i-W])||(i<N-W&&!a[i+W]))a[i]=Math.min(a[i],140)}}
 return {a,fr,box:[x0,y0,x1,y1],edgeTouch,med,sd,tol};
`);

function soft(a,W,H,bg){const N=W*H;
 const box=(src,R)=>{const t=new Float32Array(N),o=new Float32Array(N);for(let y=0;y<H;y++){let acc=0;const row=y*W;for(let x=-R;x<=R;x++)acc+=src[row+Math.min(W-1,Math.max(0,x))];for(let x=0;x<W;x++){t[row+x]=acc/(2*R+1);acc+=src[row+Math.min(W-1,x+R+1)]-src[row+Math.max(0,x-R)]}}
  for(let x=0;x<W;x++){let acc=0;for(let y=-R;y<=R;y++)acc+=t[Math.min(H-1,Math.max(0,y))*W+x];for(let y=0;y<H;y++){o[y*W+x]=acc/(2*R+1);acc+=t[Math.min(H-1,y+R+1)*W+x]-t[Math.max(0,y-R)*W+x]}}return o};
 /* 1. smooth the outline: heavy blur, then cut at half, so bumps and specks along the rim disappear */
 const R=Math.max(3,Math.round(Math.min(W,H)/180));let b=new Float32Array(N);for(let i=0;i<N;i++)b[i]=a[i]>0?255:0;b=box(box(b,R),R);
 /* 2. pull the edge in: more on dark backdrops, where the rim carries the old background */
 const lum=bg?(bg[0]*299+bg[1]*587+bg[2]*114)/1000:200;const thr=lum<70?175:150;
 let m=new Float32Array(N);for(let i=0;i<N;i++)m[i]=b[i]>=thr?255:0;
 /* 3. feather a soft anti-aliased edge */
 m=box(box(m,1),1);const out=new Uint8ClampedArray(N);for(let i=0;i<N;i++)out[i]=m[i];return out}
function shade(c,cx,cy,rx,ry,al){c.save();c.translate(cx,cy);c.scale(1,ry/rx);const g=c.createRadialGradient(0,0,0,0,0,rx);g.addColorStop(0,'rgba(30,30,34,'+al+')');g.addColorStop(0.55,'rgba(30,30,34,'+(al*0.45)+')');g.addColorStop(1,'rgba(30,30,34,0)');c.fillStyle=g;c.beginPath();c.arc(0,0,rx,0,Math.PI*2);c.fill();c.restore()}
/* make(src, mode, small): the studio render for one photo.
   mode: 'stone' (cut-out expected), 'auto' (cut-out if the photo is a plain stone shot, framed print otherwise), 'photo' (framed print).
   small: true for thumbnails in grids (similar stones, recently viewed) — a 480px render from a 600px source, so a grid costs a fraction of the hero.
   Speed: the photo is fetched at the same size the gallery already requests (1300px, one download for both), the outline is found on a 700px copy
   (4x fewer pixels), and only the stone's own crop is read at full resolution. */
async function make(src,mode,small){
 const key=mode+(small?'-s':'')+'|'+src;if(cache.has(key))return cache.get(key);
 const p=(async()=>{
  const SZ=small?600:1300,O=small?480:OUT;
  const im=await load(sized(src,SZ));
  const S=Math.min(1,SZ/Math.max(im.width,im.height));const W=Math.round(im.width*S),H=Math.round(im.height*S);
  const c=document.createElement('canvas');c.width=W;c.height=H;const x=c.getContext('2d',{willReadFrequently:true});x.drawImage(im,0,0,W,H);
  /* outline on a reduced copy */
  const s2=Math.min(1,700/Math.max(W,H));const w2=Math.max(2,Math.round(W*s2)),h2=Math.max(2,Math.round(H*s2));
  let r;if(s2<1){const c2=document.createElement('canvas');c2.width=w2;c2.height=h2;const x2=c2.getContext('2d',{willReadFrequently:true});x2.drawImage(im,0,0,w2,h2);r=seg(x2.getImageData(0,0,w2,h2).data,w2,h2)}else r=seg(x.getImageData(0,0,W,H).data,W,H);
  r.a=soft(r.a,w2,h2,r.med);
  const o=document.createElement('canvas');o.width=o.height=O;const ox=o.getContext('2d');
  /* box back at full size (a 1px margin keeps the feathered edge inside the crop) */
  const fx=W/w2,fy=H/h2;const B=[Math.max(0,Math.floor(r.box[0]*fx)-1),Math.max(0,Math.floor(r.box[1]*fy)-1),Math.min(W-1,Math.ceil(r.box[2]*fx)+1),Math.min(H-1,Math.ceil(r.box[3]*fy)+1)];
  const bw=B[2]-B[0]+1,bh=B[3]-B[1]+1;let pale=0;
  const ok=mode!=='photo'&&r.fr>0.012&&r.fr<0.62&&r.edgeTouch<=1&&bw>8&&bh>8&&r.sd<14;
  if(ok){
   /* full-resolution cut-out: alpha eroded and feathered in code (no canvas filters, so Safari matches Chrome), and edge colours un-mixed from the old background so no dark or grey halo is left */
   const sx=B[0],sy=B[1],sw=bw,sh=bh;const src=x.getImageData(sx,sy,sw,sh),dd=src.data,bg=r.med;
   /* alpha: the reduced outline scaled up to the crop (bilinear), then the edge pulled back to a crisp ~2px feather */
   const ac=document.createElement('canvas');ac.width=w2;ac.height=h2;const aid=ac.getContext('2d').createImageData(w2,h2);for(let i=0,n2=w2*h2;i<n2;i++)aid.data[i*4+3]=r.a[i];ac.getContext('2d').putImageData(aid,0,0);
   const uc=document.createElement('canvas');uc.width=sw;uc.height=sh;const ux=uc.getContext('2d',{willReadFrequently:true});ux.imageSmoothingEnabled=true;ux.imageSmoothingQuality='high';
   ux.drawImage(ac,sx/fx,sy/fy,sw/fx,sh/fy,0,0,sw,sh);const ud=ux.getImageData(0,0,sw,sh).data;
   const n=sw*sh,AL=new Uint8ClampedArray(n);const G=Math.max(1,Math.min(2.2,fx*0.9));for(let i=0;i<n;i++)AL[i]=Math.max(0,Math.min(255,(ud[i*4+3]-128)*G+128));
   /* edge pixels take their colour from the solid stone just inside (blurred interior colour), so no dark or tinted rim from the old background */
   const RR=Math.max(3,Math.round(Math.min(sw,sh)/60)),I=new Float32Array(n),C=[0,1,2].map(()=>new Float32Array(n));for(let i=0;i<n;i++){const w=AL[i]>=250?1:0;I[i]=w;for(let ch=0;ch<3;ch++)C[ch][i]=dd[i*4+ch]*w}
   const bx=(src)=>{const t=new Float32Array(n),o=new Float32Array(n);for(let y=0;y<sh;y++){let acc=0;const row=y*sw;for(let x=-RR;x<=RR;x++)acc+=src[row+Math.min(sw-1,Math.max(0,x))];for(let x=0;x<sw;x++){t[row+x]=acc;acc+=src[row+Math.min(sw-1,x+RR+1)]-src[row+Math.max(0,x-RR)]}}for(let x=0;x<sw;x++){let acc=0;for(let y=-RR;y<=RR;y++)acc+=t[Math.min(sh-1,Math.max(0,y))*sw+x];for(let y=0;y<sh;y++){o[y*sw+x]=acc;acc+=t[Math.min(sh-1,y+RR+1)*sw+x]-t[Math.max(0,y-RR)*sw+x]}}return o};
   const bI=bx(bx(I)),bC=C.map(c=>bx(bx(c)));
   for(let i=0;i<n;i++){const al=AL[i];dd[i*4+3]=al;if(al<250&&al>0&&bI[i]>0){for(let ch=0;ch<3;ch++)dd[i*4+ch]=bC[ch][i]/bI[i]}}
   const cut=document.createElement('canvas');cut.width=sw;cut.height=sh;cut.getContext('2d').putImageData(src,0,0);
   /* how pale is the stone? brightness of its rim band (outer ~6%) sets the pool of shade under it, because the rim is what must separate from the plinth */
   const KK=Math.max(2,Math.round(Math.min(sw,sh)*0.06));let ls=0,ln=0;for(let yy=0;yy<sh;yy++)for(let xx=0;xx<sw;xx++){const i=yy*sw+xx;if(AL[i]<250)continue;let rim=false;for(let d=0;d<8&&!rim;d++){const ex=xx+[KK,-KK,0,0,KK,KK,-KK,-KK][d],ey=yy+[0,0,KK,-KK,KK,-KK,KK,-KK][d];if(ex<0||ey<0||ex>=sw||ey>=sh||AL[ey*sw+ex]<250)rim=true}if(rim){ls+=dd[i*4]*0.299+dd[i*4+1]*0.587+dd[i*4+2]*0.114;ln++}}
   pale=ln?Math.max(0,Math.min(1,((ls/ln)-120)/80)):0;plinth(ox,pale,O);

   /* same size for every stone: longest side = 50% of the frame width, height capped at 44% */
   const k=Math.min(O*0.50/sw,O*0.44/sh);const dw=sw*k,dh=sh*k;const dx=(O-dw)/2,dy=O*0.47-dh/2;
   /* contact shadow */
   shade(ox,O/2,dy+dh-dh*0.03,dw*0.46,O*0.03,0.22);
   shade(ox,O/2,dy+dh,dw*0.62,O*0.06,0.08);
   ox.drawImage(cut,dx,dy,dw,dh);
  }else{
   /* photo (hand, report card, video still): framed print on the same plinth */
   plinth(ox,0,O);const pad=O*0.09;const k=Math.min((O-2*pad)/im.width,(O-2*pad)/im.height);const dw=im.width*k,dh=im.height*k;const dx=(O-dw)/2,dy=(O-dh)/2;
   ox.save();ox.shadowColor='rgba(20,20,24,0.12)';ox.shadowBlur=O*0.03;ox.shadowOffsetY=O*0.008;ox.fillStyle='#fff';ox.fillRect(dx,dy,dw,dh);ox.restore();
   ox.drawImage(im,dx,dy,dw,dh);
  }
  const blob=await new Promise(res=>o.toBlob(res,'image/webp',0.9));
  return {url:URL.createObjectURL(blob),cut:ok,pale:ok?+pale.toFixed(2):0,fr:+r.fr.toFixed(3),sd:+r.sd.toFixed(1),bg:r.med.join(',')};
 })();
 cache.set(key,p);p.catch(()=>cache.delete(key));return p;
}
return {make};
})();
;
/* v29 — one studio look for every stone photo (gallery, thumbnails, similar stones, recently viewed).
   Images are re-rendered in the visitor's browser and cached; product images in Shopify are untouched.
   Order of work: the hero first, then the thumbnails (small renders), then grid tiles only as they scroll near the screen.
   While a full render is being made, the small render of the same photo (if there is one) stands in, so the stage is never blank for long. */
(function(){if(window.__gmStudioOn)return;window.__gmStudioOn=1;var D=document;
var css='html body #gmv2 .stage{background:#E8E6E1!important}'+
'html body #gmv2 .stage img.gm-st,html body #gmv2 .thumbs img.gm-st,html body #gmv2 .sim img.gm-st{mix-blend-mode:normal!important;object-fit:cover!important;width:100%!important;height:100%!important}'+
'html body #gmv2 .thumbs button{background:#E8E6E1!important;overflow:hidden}'+
'html body #gmv2 .sim .im{background:#E8E6E1!important;aspect-ratio:1/1;overflow:hidden}'+
'html body #gmv2 img.gm-wait{opacity:0}html body #gmv2 img.gm-st{opacity:1;transition:opacity .25s}'+
'html body #gmv2 .stage:has(img.gm-wait)::after{content:"";position:absolute;inset:0;pointer-events:none;background:radial-gradient(circle at 50% 47%,rgba(255,255,255,.6),rgba(255,255,255,0) 42%);animation:gm-sh 1.1s ease-in-out infinite alternate}'+
'@keyframes gm-sh{from{opacity:.25}to{opacity:1}}'+
'@media(prefers-reduced-motion:reduce){html body #gmv2 .stage:has(img.gm-wait)::after{animation:none}html body #gmv2 img.gm-st{transition:none}}'+
'html body [id*=recently_viewed] img.gm-st{object-fit:cover!important;background:#E8E6E1}';
var s=D.createElement('style');s.id='gm-v28';s.textContent=css;D.head.appendChild(s);
function studioCacheName(){
 var engine=window.GMStudio;
 if(!engine || engine.v===undefined)return 'gm-studio-v7';
 var ev=Number(engine.v);
 if(!Number.isFinite(ev) || ev<8)return null;
 try{
  var current=D.currentScript,scripts=Array.prototype.slice.call(D.scripts),at=scripts.indexOf(current),loader=null;
  if(at<0)return null;
  for(var i=0;i<at;i++){
   var node=scripts[i],src=node.getAttribute('src');
   if(!src)continue;
   var u=new URL(src,D.baseURI);
   if(!/\/gm-studio-v8\.js$/.test(u.pathname))continue;
   if(u.protocol!=='http:' && u.protocol!=='https:')return null;
   var versions=u.searchParams.getAll('v');
   if(loader || node.async || versions.length!==1 || !/^[A-Za-z0-9._-]{1,128}$/.test(versions[0]))return null;
   loader=u.origin+u.pathname+'?v='+encodeURIComponent(versions[0]);
  }
  return loader?'gm-pdp-studio-v'+ev+'-asset-'+encodeURIComponent(loader):null;
 }catch(e){return null}
}
var CK=studioCacheName(),mem={};
/* renders from earlier versions are dropped from the visitor's storage */
try{if('caches' in window)caches.keys().then(function(ks){ks.forEach(function(k){if(/^(gm-studio-|gm-pdp-studio-v)/.test(k)&&k!==CK)caches.delete(k)})}).catch(function(){})}catch(e){}
function key(src){return src.replace(/^https?:/,'').replace(/([?&])(width|height|crop)=[^&]*/g,'$1').replace(/[?&]+$/,'')}
async function fromCache(k){try{if(!CK || !('caches' in window))return null;var c=await caches.open(CK);var r=await c.match('/__gmst/'+encodeURIComponent(k));return r?URL.createObjectURL(await r.blob()):null}catch(e){return null}}
async function toCache(k,url){try{if(!CK || !('caches' in window))return;var b=await (await fetch(url)).blob();var c=await caches.open(CK);await c.put('/__gmst/'+encodeURIComponent(k),new Response(b,{headers:{'Content-Type':'image/webp'}}))}catch(e){}}
function studioSource(src){try{var u=new URL(src,location.href);u.searchParams.delete('width');return u.href}catch(e){return src.replace(/^\/\//,location.protocol+'//')}}
function studio(src,mode,small){var k=mode+(small?'-s':'')+'|'+key(src);if(mem[k])return mem[k];
 mem[k]=(async function(){var u=await fromCache(k);if(u)return u;if(!window.GMStudio)return null;var r=await GMStudio.make(studioSource(src),mode,small);toCache(k,r.url);return r.url})().catch(function(){delete mem[k];return null});
 return mem[k]}
function sameOrigin(src){return /\/cdn\/shop\/|cdn\.shopify\.com/.test(src)&&!/\.gif|\.svg/i.test(src)}
function swap(img,u){img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=u;img.classList.add('gm-st');img.classList.remove('gm-wait')}
/* returns the render's promise (null when the image is left alone) */


/* The studio cut-out render below is switched off. Keep a no-op so the callers (run, lazy) do not throw "treat is not defined" on every page change. */
function treat(img,mode,small){return null}
// function treat(img,mode,small){
// if(!img.isConnected)return null;/* opaque, veined stones (turquoise, lapis, tiger eye, jasper) go through the same studio: checked on the draft, the veins survive the cut-out */
//  var src=img.getAttribute('src')||'';if(!src||src.indexOf('blob:')===0||!sameOrigin(src))return null;if(img.__gmSrc===src)return img.__gmP||null;img.__gmSrc=src;img.__gmFull=0;
//  if(!img.complete||mode==='stone')img.classList.add('gm-wait');
//  var p=studio(src,mode,small);img.__gmP=p;
//  if(!small){var sk=mode+'-s|'+key(src);if(mem[sk])mem[sk].then(function(u){if(u&&img.__gmSrc===src&&!img.__gmFull)swap(img,u)})}
//  p.then(function(u){if(img.__gmSrc!==src)return;if(u){img.__gmFull=1;swap(img,u)}else{img.__gmSrc=null;img.__gmP=null}img.classList.remove('gm-wait')});
//  setTimeout(function(){img.classList.remove('gm-wait')},2500);return p}
// /* grid tiles: rendered only when they come within ~600px of the screen */

var io=('IntersectionObserver' in window)?new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){io.unobserve(e.target);treat(e.target,'stone',true)}})},{rootMargin:'600px 320px'}):null;
function lazy(t){if(t.__gmObs)return;t.__gmObs=1;if(io)io.observe(t);else treat(t,'stone',true)}
var busy=0;function run(){busy=0;var g=D.getElementById('gmv2');if(!g)return;
 var st=g.querySelector('.stage img');var th=[].slice.call(g.querySelectorAll('.thumbs img'));
 var idx=th.findIndex(function(t){return t.closest('button')&&t.closest('button').classList.contains('on')});
 /* first photo = the stone; other photos: cut-out if the photo is a plain stone shot, framed print otherwise */
 var hero=st?treat(st,idx<=0?'stone':'auto'):null;
 /* thumbnails after the first get the small render only; the full render is made when one is opened, with the small one standing in meanwhile */
 var rest=function(){
if(!g.isConnected||D.getElementById('gmv2')!==g)return;th.forEach(function(t,i){if(i===0)treat(t,'stone');else treat(t,'auto',true)});
  [].slice.call(g.querySelectorAll('.sim img')).forEach(lazy);
  [].slice.call(D.querySelectorAll('[id*=recently_viewed] img')).slice(0,12).forEach(lazy)};
 if(hero&&!st.__gmFull)hero.then(rest,rest);else rest()}
function sched(){if(busy)return;busy=1;(window.requestIdleCallback?requestIdleCallback(run,{timeout:300}):setTimeout(run,60))}
new MutationObserver(sched).observe(D.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['src']});
sched();})();
;
(function(){var s=document.createElement('style');s.id='gm-v32';s.textContent='html body #gmv2 .sold{background:rgba(247,247,245,.38)!important}';document.head.appendChild(s)})();;
/* v33 — ring/pendant design captions and the chosen-design photo, also for designs the theme swaps in later (gold sets) */
(function(){if(window.__gm33)return;window.__gm33=1;var D=document;var esc=function(s){return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})};
function amt(it){if(it.dataset.settingAmount)return it.dataset.settingAmount.replace(/\s*INR/i,'').trim();var m=((it.querySelector('p')||{}).textContent||'').match(/₹\s?[\d,]+/);return m?m[0].replace(/\s/g,''):''}
function fix(){var w=D.getElementById('gm-wear');if(!w)return;
 [].slice.call(w.querySelectorAll('.design-options .design-item')).forEach(function(it){if(it.querySelector('.gm-cap'))return;var a=amt(it),adv=it.dataset.settingAdvance==='true'||/advance/i.test((it.querySelector('p')||{}).textContent||'');var mc=((it.querySelector('.making-charge')||it.querySelector('p')||{}).textContent||'').match(/\d+%/);var c=D.createElement('span');c.className='gm-cap';c.innerHTML='<b>'+esc(it.dataset.value||'')+'</b><small>'+(a?(adv?esc(a)+' advance':'+'+esc(a)):'')+(mc?' · +'+mc[0]+' making':'')+'</small>';it.appendChild(c)});
 var img=w.querySelector('.selected-design-image img');if(img&&!img.getAttribute('src')){var name=(w.querySelector('#selected-option')||{}).textContent;var src=null;[].slice.call(w.querySelectorAll('.design-options .design-item')).forEach(function(it){if(it.dataset.value===name){var m=((it.querySelector('.design-item-image')||{}).getAttribute&&it.querySelector('.design-item-image').getAttribute('style')||'').match(/url\(([^)]+)\)/);if(m&&!src)src=m[1].replace(/['"]/g,'')}});if(src)img.setAttribute('src',src)}}
var q=0;new MutationObserver(function(){if(q)return;q=1;setTimeout(function(){q=0;fix()},40)}).observe(D.documentElement,{childList:true,subtree:true});fix();})();
;
/* v34 — cart shows the ring/pendant design the customer picked: send its photo as a hidden line property */
(function(){if(window.__gm34)return;window.__gm34=1;var D=document;
function sync(){var w=D.getElementById('gm-wear');if(!w)return;var idIn=D.querySelector('input[name="items[1][id]"]');var ex=D.querySelector('input[name="items[1][properties][_design_image]"]');
 var sel=w.querySelector('.design-options .design-item.selected');var wear=w.querySelector('.wear-choice .design-item.selected');var loose=!wear||/loose/i.test(wear.dataset.value||'');
 var src=null;if(sel&&!loose){var bg=sel.querySelector('.design-item-image');var m=((bg&&getComputedStyle(bg).backgroundImage)||'').match(/url\("?([^")]+)"?\)/)||((bg&&bg.getAttribute('style'))||'').match(/url\(([^)]+)\)/);if(m)src=m[1].replace(/['"]/g,'').replace(/&quot;/g,'');if(!src){var im=sel.querySelector('img');if(im)src=im.getAttribute('src')}}
 if(src&&src.indexOf('//')===0)src='https:'+src;
 if(!idIn||!src){if(ex)ex.remove();return}
 if(!ex){ex=D.createElement('input');ex.type='hidden';ex.name='items[1][properties][_design_image]';var f=idIn.getAttribute('form');if(f)ex.setAttribute('form',f);idIn.parentNode.insertBefore(ex,idIn.nextSibling)}
 ex.value=src.split('?')[0];ex.disabled=idIn.disabled}
var q=0;new MutationObserver(function(){if(q)return;q=1;setTimeout(function(){q=0;sync()},60)}).observe(D.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['class','disabled','style']});
D.addEventListener('click',function(e){sync();setTimeout(sync,120)},true);D.addEventListener('submit',sync,true);sync();})();
;
/* v36 — ring size: one step, no alarm. Indian sizes are pre-selected (US and “I Don’t Know” stay one tap away); the helper line is quiet grey and only says what is actually missing; it turns amber only after Buy is tapped with something missing. */
(function(){if(window.__gm36)return;window.__gm36=1;var D=document;var s=D.createElement('style');s.id='gm-v36';s.textContent='html body #gmv2 .gm-hint{color:#5E5E66!important;font-size:13px!important;line-height:1.45}html body #gmv2 .gm-hint.gm-warn{color:#94560A!important}';D.head.appendChild(s);
var warnUntil=0;D.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('[data-buy],[data-buynow]'))warnUntil=Date.now()+6000},true);
function vis(e){return e&&e.offsetParent!==null}
function run(){var w=D.getElementById('gm-wear');if(!w)return;var wear=w.querySelector('.wear-choice .design-item.selected');var loose=!wear||/loose/i.test(wear.dataset.value||'');
 var sys=D.getElementById('ring-size-system');if(!loose&&sys&&vis(sys)&&!sys.value&&!sys.__gmAuto){var o=[].slice.call(sys.options).find(function(o){return /indian/i.test(o.value+o.text)});if(o){sys.__gmAuto=1;sys.value=o.value;sys.dispatchEvent(new Event('change',{bubbles:true}))}}
 var h=D.querySelector('#gmv2 .gm-hint');if(!h)return;var des=w.querySelector('.design-options .design-item.selected')||w.querySelector('#selected-option');var selects=[].slice.call(w.querySelectorAll('select')).filter(vis);var noSize=selects.some(function(x){return !x.value||/^select/i.test(x.value)});
 var t=!des?'Choose a design above.':noSize?'Choose your ring size. Not sure? Pick \u201CI Don\u2019t Know\u201D and we will call you to measure.':'';if(h.textContent!==t)h.textContent=t;h.style.display=t?'':'none';h.classList.toggle('gm-warn',Date.now()<warnUntil)}
var q=0;new MutationObserver(function(){if(q)return;q=1;setTimeout(function(){q=0;run()},50)}).observe(D.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});D.addEventListener('change',function(){setTimeout(run,60)},true);run();})();

;/* v37 — mobile: one floating button only. The phone number already sits in the top strip and the buy bar has a chat button, so the round call bubble on the left is hidden on phones; WhatsApp bubble is a little smaller. */
(function(){if(window.__gm37)return;window.__gm37=1;var s=document.createElement('style');s.id='gm-v37';s.textContent='@media (max-width:768px){html:has(#gmv2) #call-now-button{display:none!important}html:has(#gmv2) .qr_wa_icon{transform:scale(.85);transform-origin:bottom right}}';document.head.appendChild(s)})();
;
(function(){if(!document.getElementById("gm-v27")){var css="html body #gmv2.gm-sold .proof .btns{display:none!important}html body #gmv2 #gm-sim{scroll-margin-top:120px}html body #gmv2 .qb .qbs{font-size:14px;color:#3C3C43;text-decoration:underline;text-underline-offset:3px;text-align:center;min-height:44px;display:flex;align-items:center;justify-content:center}",s=document.createElement("style");s.id="gm-v27",s.textContent=css,document.head.appendChild(s)}})(),(function(){if(!document.getElementById("gm-v25")){var css="html body #gmv2 #gm-wear #change-design{display:inline-flex!important;align-items:center;min-height:44px;padding:0 14px;margin:6px 0;border:1px solid #111113;background:#fff;color:#111113!important;font-weight:600;cursor:pointer;border-radius:2px;text-decoration:none!important}@media(min-width:960px){html.gm-sb .qr_wa_icon,html.gm-sb #call-now-button,html.gm-sb #zsiq_float{bottom:112px!important;transition:bottom .25s}}",s=document.createElement("style");s.id="gm-v25",s.textContent=css,document.head.appendChild(s)}})(),(function(){if(document.getElementById("gm-v24"))return;var D=document,css='html body #gmv2 #gm-wear .selected-design{gap:12px!important;align-items:center!important;padding:10px 12px!important;border:1px solid #E7E7E4!important;border-radius:2px!important;background:#F7F7F5!important;font-size:14px!important;line-height:1.45!important;margin:0!important}html body #gmv2 #gm-wear .selected-design-image{flex:none!important;width:64px!important;height:64px!important;margin:0!important;padding:0!important;background:#fff!important;border:0!important;border-radius:0!important}html body #gmv2 #gm-wear .selected-design-image img{width:100%!important;height:100%!important;object-fit:contain!important;mix-blend-mode:multiply}html body #gmv2 #gm-wear .selected-design-image:has(img[src=""]),html body #gmv2 #gm-wear .selected-design-image:has(img:not([src])){display:none!important}',s=D.createElement("style");s.id="gm-v24",s.textContent=css,D.head.appendChild(s);function fill(){var w=D.getElementById("gm-wear");if(w){var img=w.querySelector(".selected-design-image img");if(!(!img||img.getAttribute("src"))){var sel=w.querySelector(".design-options .design-item.selected .design-item-image");if(sel){var m=(sel.getAttribute("style")||"").match(/url\(([^)]+)\)/);m&&img.setAttribute("src",m[1].replace(/['"]/g,""))}}}}D.addEventListener("click",function(e){e.target.closest&&e.target.closest("#gm-wear")&&setTimeout(fill,150)},!0)})(),(function(){if(!document.getElementById("gm-v21")){var css="html body #gmv2 .rit{gap:8px;scroll-snap-type:x mandatory;scrollbar-width:none}html body #gmv2 .rit::-webkit-scrollbar{display:none}html body #gmv2 .rit button{width:150px;min-height:0;padding:9px 9px 8px;gap:2px;scroll-snap-align:start;border-radius:2px}html body #gmv2 .rit small{font-size:12px;letter-spacing:.08em;min-height:0;line-height:1.3}html body #gmv2 .rit b{font-size:14px;line-height:1.25;font-weight:600;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}html body #gmv2 .rit em{font-size:12px;line-height:1.3;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}html body #gmv2 .rit strong{font-size:15px!important;line-height:1.2;margin-top:auto;padding-top:4px}@media(min-width:768px){html body #gmv2 .rit button{width:150px}}html body #gmv2 #gm-wear .wear-choice .design-item{min-height:76px!important;gap:5px!important;padding:9px 6px!important}html body #gmv2 #gm-wear .wear-choice .design-item-image{width:26px!important;height:26px!important}html body #gmv2 .rit{padding:0 16px 4px!important;scroll-padding-left:16px}html body #gmv2 .rit b{letter-spacing:-.005em}html body #gmv2 #gm-wear .wear-choice .design-item p{font-size:13px!important;line-height:1.2!important}",s=document.createElement("style");s.id="gm-v21",s.textContent=css,document.head.appendChild(s)}})(),(function(){if(!document.getElementById("gm-v20")){var css="html body #gmv2 .ship svg{display:inline-block;vertical-align:-4px;margin-right:6px}html body .gmv2-sticky .p{flex:1 1 auto;min-width:0}html body .gmv2-sticky .p span{display:block;white-space:normal;line-height:1.3}html body .gmv2-sticky a{flex:none}html body #gmv2 #gm-wear .shipping-delivery-wrapper{background:#F7F7F5!important;border:1px solid #E7E7E4!important;border-radius:2px!important;box-shadow:none!important}",s=document.createElement("style");s.id="gm-v20",s.textContent=css,document.head.appendChild(s)}})(),(function(){if(!document.getElementById("gm-v19")){var s=document.createElement("style");s.id="gm-v19",s.textContent="html body #gmv2 button,html body #gmv2 a.ob,html body #gmv2 a.buy,html body #gmv2 .card,html body #gmv2 .proof{border-radius:2px!important}@media(max-width:599px){html body #gmv2 #gm-wear .metal-options .design-container{grid-template-columns:repeat(2,minmax(0,1fr))!important}}@media(max-width:767px){html body #gmv2 #gm-wear .design-options .design-container{grid-template-columns:none!important;grid-auto-flow:column;grid-auto-columns:40%;overflow-x:auto;overflow-y:hidden;max-height:none!important;scroll-snap-type:x mandatory;padding-bottom:8px}html body #gmv2 #gm-wear .design-options .design-item{scroll-snap-align:start}}",document.head.appendChild(s)}})(),(function(){if(!document.getElementById("gm-v18")){var s=document.createElement("style");s.id="gm-v18",s.textContent="#gmv2 .det{max-width:1240px!important}#gmv2 .h{margin:60px 0 18px!important}#gmv2 .sim{gap:16px!important}#gmv2 .sim a{width:190px!important}#gmv2 .sim .im{height:auto!important;aspect-ratio:1/1;background:#F5F5F3!important;overflow:hidden}#gmv2 .sim img{object-fit:cover!important;mix-blend-mode:normal!important;transition:transform .4s ease}#gmv2 .sim a:hover img{transform:scale(1.04)}#gmv2 .sim b{font-size:18px!important;margin-top:10px!important}@media(min-width:1024px){#gmv2 .sim{display:grid!important;grid-template-columns:repeat(6,minmax(0,1fr));overflow:visible!important}#gmv2 .sim a{width:auto!important}}#gmv2 .box{grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:12px!important}@media(min-width:768px){#gmv2 .box{grid-template-columns:repeat(3,minmax(0,1fr))!important}}#gmv2 .box div{padding:22px 20px!important;border:1px solid #EFEFEC;background:#FAFAF8!important}#gmv2 .box b{font-size:19px!important;margin-bottom:6px}#gmv2 .size.gi{background:#F7F7F5;display:flex;justify-content:center;padding:0!important}#gmv2 .size.gi img{width:100%;max-width:620px;height:auto;display:block;mix-blend-mode:multiply}@media(min-width:1024px){#gmv2 .rows{display:grid;grid-template-columns:1fr 1fr;column-gap:64px}}@media(min-width:1024px){#gmv2 .revs{display:grid;grid-template-columns:1fr 1fr;gap:16px;align-items:stretch}#gmv2 .revs>*{margin:0!important}#gmv2 .revs .note{display:flex;align-items:center}}@media(min-width:1024px){#gmv2 .gmfaq{display:grid;grid-template-columns:1fr 1fr;column-gap:64px;align-items:start}}@media(min-width:768px){#gmv2 .pk{padding:48px 48px!important}}[id*=recently_viewed] .section-spacing,[id*=recently_viewed] .color-scheme{background:#fff!important}@media(min-width:1024px){[id*=recently_viewed] .container{max-width:1240px!important;margin-left:auto!important;margin-right:auto!important}}[id*=recently_viewed] .ctm_p{font-family:Jost,sans-serif!important;font-size:12px!important;letter-spacing:.16em!important;color:#7E5F27!important;font-weight:500!important}[id*=recently_viewed] h2{font-family:'Playfair Display',Georgia,serif!important;font-weight:400!important;color:#111113!important}[id*=recently_viewed] product-card{border:1px solid #E7E7E4!important;border-radius:2px!important;box-shadow:none!important;background:#fff!important;overflow:hidden}[id*=recently_viewed] product-card *{border-radius:0!important}[id*=assay_strip]{overflow-x:clip!important}#gmv2 .size.gi{height:auto!important;min-height:0!important}",document.head.appendChild(s);var rv=document.querySelector('[id*="recently_viewed"]');rv&&[rv].concat([].slice.call(rv.querySelectorAll(".section-spacing,.color-scheme"))).forEach(function(e){e.style.setProperty("background","#fff","important"),e.style.setProperty("background-color","#fff","important")})}})(),(function(){if(!document.getElementById("gm-v17")){var s=document.createElement("style");s.id="gm-v17",s.textContent=`#gmv2 #gm-wear{padding:4px 16px 0;font-family:Mukta,Jost,system-ui,sans-serif;color:#111113}#gmv2 #gm-wear .gm-opt__bar{display:none!important}#gmv2 #gm-wear .option-label{font-family:Jost,sans-serif!important;font-size:12px!important;letter-spacing:.12em!important;text-transform:uppercase!important;color:#111113!important;margin:18px 0 8px!important;font-weight:500!important;line-height:1.4!important}#gmv2 #gm-wear .wear-choice .option-label{margin-top:4px!important}#gmv2 #gm-wear .wear-choice .option-label span{display:none!important}#gmv2 #gm-wear .design-container{display:grid!important;grid-template-columns:repeat(3,minmax(0,1fr))!important;gap:8px!important;flex-wrap:initial!important}#gmv2 #gm-wear .design-item{position:relative;border:1px solid #D4D4D0!important;border-radius:2px!important;background:#fff!important;box-shadow:none!important;margin:0!important;width:auto!important;cursor:pointer;transition:border-color .15s}#gmv2 #gm-wear .design-item:hover{border-color:#8A8A90!important}#gmv2 #gm-wear .design-item.selected{border-color:#111113!important;box-shadow:inset 0 0 0 1px #111113!important;background:#fff!important}#gmv2 #gm-wear .design-item::after,#gmv2 #gm-wear .design-item::before{display:none!important}#gmv2 #gm-wear .wear-choice .design-item{min-height:104px;display:flex!important;flex-direction:column;align-items:center;justify-content:center;gap:8px;padding:12px 6px!important}#gmv2 #gm-wear .wear-choice .design-item-image{border:0!important;box-shadow:none!important;width:36px!important;height:36px!important;min-width:0!important;background-color:transparent!important;filter:grayscale(1) brightness(.3);border-radius:0!important;padding:0!important;margin:0!important}#gmv2 #gm-wear .wear-choice .design-item p{font-size:14px!important;font-weight:600!important;margin:0!important;line-height:1.25!important;text-align:center;color:#111113!important}#gmv2 #gm-wear .metal-options .design-container{grid-template-columns:repeat(4,minmax(0,1fr))!important;gap:6px!important}#gmv2 #gm-wear .metal-options .design-item{min-height:48px;display:flex!important;align-items:center;justify-content:center;padding:6px 4px!important;font-size:14px!important;text-align:center}#gmv2 #gm-wear .metal-options .design-item *{font-size:14px!important;background:none!important;border:0!important;width:auto!important;height:auto!important;color:inherit!important;box-shadow:none!important}#gmv2 #gm-wear .metal-options .design-item.selected{background:#12151D!important;color:#fff!important;border-color:#12151D!important;box-shadow:none!important}#gmv2 #gm-wear .design-options .design-container{max-height:560px;overflow:auto;padding-right:2px}@media(min-width:1024px){#gmv2 #gm-wear .design-options .design-container{grid-template-columns:repeat(4,minmax(0,1fr))!important}}#gmv2 #gm-wear .design-options .design-item{display:flex!important;flex-direction:column;padding:0 0 10px!important;text-align:center;border-color:#E7E7E4!important}#gmv2 #gm-wear .design-options .design-item.selected{border-color:#111113!important}#gmv2 #gm-wear .design-options .design-item-image{width:100%!important;height:auto!important;aspect-ratio:1/1;background-color:#F7F7F5!important;background-size:contain!important;background-repeat:no-repeat!important;background-position:center!important;border:0!important;border-radius:0!important;margin:0!important;box-shadow:none!important}#gmv2 #gm-wear .design-options .design-item img{width:100%;height:100%;object-fit:contain;mix-blend-mode:multiply}#gmv2 #gm-wear .design-options .design-item>p,#gmv2 #gm-wear .design-options .making-charge{display:none!important}#gmv2 #gm-wear .gm-cap{display:block;padding:8px 6px 0;line-height:1.3}#gmv2 #gm-wear .gm-cap b{display:block;font-weight:600;font-size:14px}#gmv2 #gm-wear .gm-cap small{display:block;color:#5E5E66;font-size:12px}#gmv2 #gm-wear .design-options>p:not(.option-label),#gmv2 #gm-wear .design-options>div:not(.design-container){font-size:14px;color:#3C3C43}#gmv2 #gm-wear .design-options a{color:#111113!important;font-weight:600;text-decoration:underline;text-underline-offset:3px}#gmv2 #gm-wear .size-item{display:flex!important;flex-direction:column!important;align-items:stretch!important;justify-content:flex-start!important;gap:8px!important;margin:18px 0 0!important;width:100%!important}#gmv2 #gm-wear .size-item label{font-family:Jost,sans-serif;font-size:12px;letter-spacing:.12em;text-transform:uppercase;color:#111113;font-weight:500}#gmv2 #gm-wear select{width:100%!important;max-width:none!important;height:48px!important;border:1px solid #D4D4D0!important;border-radius:2px!important;background:#fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' fill='none' stroke='%23111113' stroke-width='1.5'/%3E%3C/svg%3E") no-repeat right 16px center!important;-webkit-appearance:none!important;appearance:none!important;padding:0 44px 0 14px!important;font-size:15px!important;color:#111113!important;text-align:left!important;text-align-last:left!important;direction:ltr!important;cursor:pointer;margin:0!important}#gmv2 #gm-wear select:focus{outline:2px solid #12151D;outline-offset:2px}#gmv2 #gm-wear a{display:inline-flex;align-items:center;min-height:44px}#gmv2 #gm-wear .hide,#gmv2 #gm-wear [style*="display: none"],#gmv2 #gm-wear [style*="display:none"]{display:none!important}`,document.head.appendChild(s)}})(),(function(){if(!document.getElementById("gm-gal-premium")){var css="#gmv2 .stage{background:#F7F7F5}#gmv2 .chip{background:transparent;color:#63636B;font-size:12px;letter-spacing:.16em;padding:4px 2px;top:14px;left:16px}#gmv2 .live{background:rgba(255,255,255,.72);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);border:1px solid #E7E7E4;font-weight:500;font-size:12px;letter-spacing:.06em;top:10px;right:10px}#gmv2 .cap{background:transparent;color:#8A8A90;font-size:12px;letter-spacing:.04em;left:16px;bottom:12px}#gmv2 .thumbs{gap:8px;margin-top:8px}#gmv2 .thumbs button{border:1px solid transparent;background:#F7F7F5;opacity:.72;transition:opacity .2s}#gmv2 .thumbs button:hover{opacity:1}#gmv2 .thumbs button.on{border:1px solid #111113;opacity:1}@media(min-width:1024px){#gmv2 .gal{max-width:600px}}",s=document.createElement("style");s.id="gm-gal-premium",s.textContent=css,document.head.appendChild(s)}})(),(function(){if(window.__gmv13)return;window.__gmv13=1;var D=document,css="#gm-wear{padding:0 16px}#gm-wear a{display:inline-flex;align-items:center;min-height:44px}#gm-wear.gm-need{outline:2px solid #94560A;outline-offset:4px}#gmv2 .gm-hint{padding:8px 16px 0;color:#94560A}@media(min-width:960px){#gmv2 .wgrid{max-height:150px}}#gmv2 .qb{display:none}@media(min-width:960px){#gmv2 .top{flex-wrap:nowrap;gap:0 40px}#gmv2 .gal{flex:1 1 52%}#gmv2 .info{flex:1 1 44%}}@media(min-width:960px){#gmv2 .qb{display:grid;grid-template-columns:1fr;gap:8px;margin:14px 0 4px}#gmv2 .qb .buy{display:flex;align-items:center;justify-content:center;text-decoration:none}#gmv2 .qb2{font-size:14px;color:#3C3C43;text-decoration:underline;text-underline-offset:3px;text-align:center;min-height:44px;display:flex;align-items:center;justify-content:center}}",s=D.createElement("style");s.id="gm-v13",s.textContent=css,D.head.appendChild(s);var tick=0;function upd(){tick=0;if(window.__gmStickySync){window.__gmStickySync();return}var q=D.querySelector("#gmv2 .qb .buy"),all=D.querySelectorAll("#gmv2 .buy"),last=all[all.length-1];if(!q||innerWidth<960){D.documentElement.classList.remove("gm-sb");return}var a=q.getBoundingClientRect(),b=last&&last!==q?last.getBoundingClientRect():null,show=a.bottom<0&&!(b&&b.top<innerHeight&&b.bottom>0);D.documentElement.classList.toggle("gm-sb",show)}addEventListener("scroll",upd,{passive:!0}),addEventListener("resize",upd),upd(),D.addEventListener("click",function(e){var a=e.target.closest("#gmv2 .qb2");if(a){e.preventDefault();var t=D.getElementById("gm-cfg");t&&t.scrollIntoView({behavior:"smooth",block:"start"})}})})(),(async function () {
  const W = window,
    D = document,
    handle = location.pathname.split("/products/")[1].split(/[?#/]/)[0],
    initialPickerGenerations = new Map([...D.querySelectorAll("variant-picker")].map(picker => [picker, picker._gmVariantGeneration])),
    P = await (await fetch(((W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || "/") + "products/" + handle + ".js")).json(),
    WA = "919217846751",
    LOOX = W.GM_REV && Number.isFinite(+W.GM_REV.r) && +W.GM_REV.r > 0 && +W.GM_REV.r <= 5 && +W.GM_REV.n > 0 ? {avg:(+W.GM_REV.r).toFixed(1),n:(+W.GM_REV.n).toLocaleString("en-IN")} : null,
    wa = (t) =>
      "https://wa.me/" +
      WA +
      "?text=" +
      encodeURIComponent(t + " " + location.origin + "/products/" + handle),
    film =
      (D.documentElement.innerHTML.match(
        /https:\/\/customer-[a-z0-9]+\.cloudflarestream\.com\/[a-f0-9]+\/iframe/,
      ) || [])[0] || null,
    specs = {};
  D.querySelectorAll(".np-spec-item").forEach((e) => {
    const k = e.querySelector(".sl"),
      v = e.querySelector(".sv");
    k && v && (specs[k.textContent.trim()] = v.textContent.trim());
  });
  if (!specs.Origin) {
    const om = (D.body.innerText.match(
      /Origin\s*:\s*([A-Za-z][A-Za-z ]{1,30})/,
    ) || [])[1];
    om && (specs.Origin = om.trim());
  }
  const repM = D.body.innerText.match(
      /Lab report\s+([A-Z]*\d{5,})\s*·\s*([A-Za-z ]+)/,
    ),
    GEM = {
      "Blue Sapphire": [
        "Neelam",
        "Shani",
        "Saturday",
        6,
        "Middle finger, working hand",
        "Silver or panchdhatu",
        "Om Sham Shanaishcharaya Namah",
        "blue-sapphire-neelam",
      ],
      "Yellow Sapphire": [
        "Pukhraj",
        "Guru",
        "Thursday",
        4,
        "Index finger",
        "Gold",
        "Om Graam Greem Graum Sah Gurave Namah",
        "yellow-sapphire-pukhraj",
      ],
      Ruby: [
        "Manik",
        "Surya",
        "Sunday",
        0,
        "Ring finger",
        "Gold or copper",
        "Om Hraam Hreem Hraum Sah Suryaya Namah",
        "ruby-manik",
      ],
      Pearl: [
        "Moti",
        "Chandra",
        "Monday",
        1,
        "Little finger",
        "Silver",
        "Om Shraam Shreem Shraum Sah Chandraya Namah",
        "pearl-moti",
      ],
      "Red Coral": [
        "Moonga",
        "Mangal",
        "Tuesday",
        2,
        "Ring finger",
        "Gold or copper",
        "Om Kraam Kreem Kraum Sah Bhaumaya Namah",
        "red-coral-moonga",
      ],
      Emerald: [
        "Panna",
        "Budh",
        "Wednesday",
        3,
        "Little finger",
        "Gold or silver",
        "Om Braam Breem Braum Sah Budhaya Namah",
        "emerald-panna",
      ],
      Emeralds: [
        "Panna",
        "Budh",
        "Wednesday",
        3,
        "Little finger",
        "Gold or silver",
        "Om Braam Breem Braum Sah Budhaya Namah",
        "emerald-panna",
      ],
      Opal: [
        "Opal",
        "Shukra",
        "Friday",
        5,
        "Middle or ring finger",
        "Silver or white gold",
        "Om Draam Dreem Draum Sah Shukraya Namah",
        "opal-stone",
      ],
      Hessonite: [
        "Gomed",
        "Rahu",
        "Saturday",
        6,
        "Middle finger",
        "Silver or panchdhatu",
        "Om Bhraam Bhreem Bhraum Sah Rahave Namah",
        "gomed",
      ],
      Amethyst: [
        "Katela",
        "Shani",
        "Saturday",
        6,
        "Middle finger",
        "Silver or panchdhatu",
        "Om Sham Shanaishcharaya Namah",
        "amethyst",
      ],
      Iolite: [
        "Kakanili",
        "Shani",
        "Saturday",
        6,
        "Middle finger",
        "Silver or panchdhatu",
        "Om Sham Shanaishcharaya Namah",
        "neeli-lolite",
      ],
      "Lapis Lazuli": [
        "Lajward",
        "Shani",
        "Saturday",
        6,
        "Middle finger",
        "Silver or panchdhatu",
        "Om Sham Shanaishcharaya Namah",
        "lapis-lazuli",
      ],
      Neeli: [
        "Neeli",
        "Shani",
        "Saturday",
        6,
        "Middle finger",
        "Silver or panchdhatu",
        "Om Sham Shanaishcharaya Namah",
        null,
      ],
      Citrine: [
        "Sunela",
        "Guru",
        "Thursday",
        4,
        "Index finger",
        "Gold",
        "Om Graam Greem Graum Sah Gurave Namah",
        "citrine",
      ],
      Moonstone: [
        "Chandrakant Mani",
        "Chandra",
        "Monday",
        1,
        "Little finger",
        "Silver",
        "Om Shraam Shreem Shraum Sah Chandraya Namah",
        "moonstone-blue-sheen",
      ],
      Peridot: [
        "Peridot",
        "Budh",
        "Wednesday",
        3,
        "Little finger",
        "Gold or silver",
        "Om Braam Breem Braum Sah Budhaya Namah",
        "peridot",
      ],
      "Green Tourmaline": [
        "Green Tourmaline",
        "Budh",
        "Wednesday",
        3,
        "Little finger",
        "Gold or silver",
        "Om Braam Breem Braum Sah Budhaya Namah",
        "colored-tourmalines",
      ],
      "Chrome Tourmaline": [
        "Chrome Tourmaline",
        "Budh",
        "Wednesday",
        3,
        "Little finger",
        "Gold or silver",
        "Om Braam Breem Braum Sah Budhaya Namah",
        "colored-tourmalines",
      ],
      Garnet: [
        "Garnet",
        "Rahu",
        "Saturday",
        6,
        "Middle finger",
        "Silver or panchdhatu",
        "Om Bhraam Bhreem Bhraum Sah Rahave Namah",
        "garnet",
      ],
      "Garnet Premium": [
        "Garnet",
        "Rahu",
        "Saturday",
        6,
        "Middle finger",
        "Silver or panchdhatu",
        "Om Bhraam Bhreem Bhraum Sah Rahave Namah",
        "garnet",
      ],
      "White Sapphire": [
        "White Pukhraj",
        "Shukra",
        "Friday",
        5,
        "Middle or ring finger",
        "Silver or white gold",
        "Om Draam Dreem Draum Sah Shukraya Namah",
        "white-sapphire",
      ],
      Zircon: [
        "Zircon",
        "Shukra",
        "Friday",
        5,
        "Middle or ring finger",
        "Silver or white gold",
        "Om Draam Dreem Draum Sah Shukraya Namah",
        null,
      ],
      BloodStone: [
        "Bloodstone",
        "Mangal",
        "Tuesday",
        2,
        "Ring finger",
        "Gold or copper",
        "Om Kraam Kreem Kraum Sah Bhaumaya Namah",
        null,
      ],
      Bloodstone: [
        "Bloodstone",
        "Mangal",
        "Tuesday",
        2,
        "Ring finger",
        "Gold or copper",
        "Om Kraam Kreem Kraum Sah Bhaumaya Namah",
        null,
      ],
      "Tiger Eye": [
        "Tiger Eye",
        "Ketu",
        "Tuesday",
        2,
        "Middle or little finger",
        "Silver or panchdhatu",
        "Om Sraam Sreem Sraum Sah Ketave Namah",
        "tigers-eye",
      ],
      Turquoise: [
        "Firoza",
        "Guru",
        "Thursday",
        4,
        "Index finger",
        "Silver",
        "Om Graam Greem Graum Sah Gurave Namah",
        "turquoise-stone",
      ],
      Firoza: [
        "Firoza",
        "Guru",
        "Thursday",
        4,
        "Index finger",
        "Silver",
        "Om Graam Greem Graum Sah Gurave Namah",
        "turquoise-stone",
      ],
      Aquamarine: [
        "Beruj",
        "Shani",
        "Saturday",
        6,
        "Middle finger",
        "Silver",
        "Om Sham Shanaishcharaya Namah",
        null,
      ],
      "Red Spinel": [
        "Red Spinel",
        "Surya",
        "Sunday",
        0,
        "Ring finger",
        "Gold or copper",
        "Om Hraam Hreem Hraum Sah Suryaya Namah",
        null,
      ],
      "Pink Spinel": [
        "Pink Spinel",
        "Surya",
        "Sunday",
        0,
        "Ring finger",
        "Gold or copper",
        "Om Hraam Hreem Hraum Sah Suryaya Namah",
        null,
      ],
      "Red Pink Spinel": [
        "Spinel",
        "Surya",
        "Sunday",
        0,
        "Ring finger",
        "Gold or copper",
        "Om Hraam Hreem Hraum Sah Suryaya Namah",
        null,
      ],
      Rubellite: [
        "Rubellite",
        "Surya",
        "Sunday",
        0,
        "Ring finger",
        "Gold or copper",
        "Om Hraam Hreem Hraum Sah Suryaya Namah",
        "colored-tourmalines",
      ],
      "Blue Spinel": [
        "Blue Spinel",
        "Shani",
        "Saturday",
        6,
        "Middle finger",
        "Silver or panchdhatu",
        "Om Sham Shanaishcharaya Namah",
        null,
      ],
      "Pink Tourmaline": [
        "Pink Tourmaline",
        "Shukra",
        "Friday",
        5,
        "Middle or ring finger",
        "Silver or white gold",
        "Om Draam Dreem Draum Sah Shukraya Namah",
        "colored-tourmalines",
      ],
      "Red Jasper": [
        "Red Jasper",
        "Mangal",
        "Tuesday",
        2,
        "Ring finger",
        "Gold or copper",
        "Om Kraam Kreem Kraum Sah Bhaumaya Namah",
        null,
      ],
      Jasper: [
        "Jasper",
        "Mangal",
        "Tuesday",
        2,
        "Ring finger",
        "Gold or copper",
        "Om Kraam Kreem Kraum Sah Bhaumaya Namah",
        "jasper",
      ],
      "Brown Jasper": [
        "Brown Jasper",
        "Mangal",
        "Tuesday",
        2,
        "Ring finger",
        "Gold or copper",
        "Om Kraam Kreem Kraum Sah Bhaumaya Namah",
        "jasper",
      ],
      "Brown Jasper Premium": [
        "Brown Jasper",
        "Mangal",
        "Tuesday",
        2,
        "Ring finger",
        "Gold or copper",
        "Om Kraam Kreem Kraum Sah Bhaumaya Namah",
        "jasper",
      ],
      Carnelian: [
        "Carnelian",
        "Mangal",
        "Tuesday",
        2,
        "Ring finger",
        "Gold or copper",
        "Om Kraam Kreem Kraum Sah Bhaumaya Namah",
        null,
      ],
      Pukhraj: [
        "Pukhraj",
        "Guru",
        "Thursday",
        4,
        "Index finger",
        "Gold",
        "Om Graam Greem Graum Sah Gurave Namah",
        "yellow-sapphire-pukhraj",
      ],
      "Cats Eye": [
        "Lehsunia",
        "Ketu",
        "Tuesday",
        2,
        "Middle or little finger",
        "Silver or panchdhatu",
        "Om Sraam Sreem Sraum Sah Ketave Namah",
        "lehsuniya-cats-eye",
      ],
    },
    G = GEM[P.type],
    GC =
      {
        Turquoise: "#3FA7A3",
        Firoza: "#3FA7A3",
        Aquamarine: "#7FC4D6",
        "Red Spinel": "#B0182F",
        "Pink Spinel": "#D2557A",
        "Red Pink Spinel": "#C42E55",
        Rubellite: "#A3133F",
        "Blue Spinel": "#2E4C9A",
        "Pink Tourmaline": "#E07AA0",
        "Red Jasper": "#9C2F22",
        Jasper: "#8A4A2C",
        "Brown Jasper": "#6E4A2E",
        "Brown Jasper Premium": "#6E4A2E",
        Carnelian: "#C4562A",
        Pukhraj: "#E0B43A",
        Amethyst: "#7B4FA0",
        Iolite: "#4B4F9E",
        "Lapis Lazuli": "#26408B",
        Neeli: "#2F3F8F",
        Citrine: "#E3A23A",
        Moonstone: "#DCDCE4",
        Peridot: "#8DB53C",
        "Green Tourmaline": "#2E7D4F",
        "Chrome Tourmaline": "#1E7A4A",
        Garnet: "#7A1F2B",
        "Garnet Premium": "#7A1F2B",
        "White Sapphire": "#EDEDEF",
        Zircon: "#E8EEF2",
        BloodStone: "#2F4F3A",
        Bloodstone: "#2F4F3A",
        "Tiger Eye": "#9A6A2A",
        "Blue Sapphire": "#2C4596",
        "Yellow Sapphire": "#E0B43A",
        Ruby: "#A3132E",
        Pearl: "#E9E2D0",
        "Red Coral": "#D4532F",
        Emerald: "#1F7A55",
        Emeralds: "#1F7A55",
        Opal: "#E6E1D6",
        Hessonite: "#9E4A1F",
        "Cats Eye": "#B39A5C",
      }[P.type] || "#2C4596",
    GEMBG =
      "radial-gradient(ellipse at 32% 28%,rgba(255,255,255,.65),rgba(255,255,255,0) 38%),linear-gradient(140deg," +
      GC +
      ",color-mix(in srgb," +
      GC +
      " 55%,#000))",
    [gName, planet, dayName, dow, finger, metal, mantra, coll] = G || [],
    num = (s) => {
      const m = String(s || "").match(/[\d.]+/);
      return m ? parseFloat(m[0]) : NaN;
    };
  if (!G) {D.documentElement.classList.remove("gm-pdp-wait");return;}
  let ct =
    num(specs.Carat) || num((P.title.match(/([\d.]+)\s*Carat/i) || [])[1]);
  function gmWeightSelection(options, variant) {
    const matches = options.map((option, index) => ({option, index, name: String(option.name || option).trim()})).filter(entry => /\b(?:weight|ratti|carats?|ct)\b/i.test(entry.name));
    if (matches.length !== 1) return {hasOption: matches.length > 0, multiple: false, selected: null};
    const {option, index, name} = matches[0], namedRatti = /\bratti\b/i.test(name), namedCarat = /\b(?:carats?|ct)\b/i.test(name);
    if (namedRatti && namedCarat) return {hasOption: true, multiple: false, selected: null};
    const namedUnit = namedRatti ? "ratti" : namedCarat ? "ct" : "";
    const parse = value => {
      const match = String(value || "").trim().match(/^(\d+(?:\.\d+)?)\s*(ratti|ct|carats?)?$/i);
      if (!match) return null;
      const amount = Number(match[1]), unit = match[2] ? /ratti/i.test(match[2]) ? "ratti" : "ct" : namedUnit;
      if (!(amount > 0) || !Number.isFinite(amount) || !unit || namedUnit && namedUnit !== unit) return null;
      return {unit, amount, carat: unit === "ct" ? amount : NaN, ratti: unit === "ratti" ? amount : NaN};
    };
    const values = Array.isArray(option.values) ? option.values.map(parse) : [], selected = variant && Array.isArray(variant.options) ? parse(variant.options[index]) : null;
    return {hasOption: true, multiple: values.length > 1 && values.every(Boolean) && new Set(values.map(value => value.unit)).size === 1 && new Set(values.map(value => value.amount)).size > 1, selected};
  }
  const wOpt = P.options.findIndex((o) => /weight/i.test(o.name || o)),
    pOpt = P.options.findIndex((o) => /pooja|energi/i.test(o.name || o)),
    multi = wOpt > -1,
    wVals = multi ? P.options[wOpt].values || [] : [],
    pVals =
      pOpt > -1 ? P.options[pOpt].values || [] : P.variants.map((v) => v.title),
    vFor = (pi, wi) =>
      P.variants.find(
        (v) =>
          (pOpt < 0 || v.options[pOpt] === pVals[pi]) &&
          (!multi || v.options[wOpt] === wVals[wi]),
      ) || null;
  let ratti = NaN;
  const CUR =
      (W.Shopify && W.Shopify.currency && W.Shopify.currency.active) || "INR",
    fmt = (n) =>
    !Number.isFinite(n) ? "Unavailable" : CUR === "INR"
        ? "\u20B9" + n.toLocaleString("en-IN", {minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2})
        : new Intl.NumberFormat("en", {
            style: "currency",
            currency: CUR,
            maximumFractionDigits: 2,
          }).format(n),
    initialForm = D.querySelector('product-form form[action*="/cart/add"],form[action*="/cart/add"]'),
    nativeId = () => String((D.forms.namedItem(initialForm && initialForm.getAttribute("id")) || initialForm)?.elements.namedItem("id")?.value || ""),
    variantById = (id) => P.variants.find((v) => String(v.id) === String(id)) || null;
  const nativeAtc = (form) => {
    if (!form) return null;
    const owner = form.closest("product-rerender"), formId = form.getAttribute("id");
    const customControls = [...(owner || form).querySelectorAll("[data-custom-main-atc]")];
    if (customControls.length) {
      const productForm = form.closest("product-form"), FormController = customElements.get("product-form"), RerenderController = customElements.get("product-rerender");
      const owned = [...form.querySelectorAll('button[type="button"][data-custom-main-atc]')].filter(button => button.closest("form") === form && button.getAttribute("data-form-id") === formId);
      const known = owner && D.documentElement.classList.contains("np-pdp") && form.querySelector(".np-total[data-np-total]") && form.closest(".product-info") &&
        owner.hasAttribute("allow-partial-rerender") && formId && owner.getAttribute("observe-form") === formId && P.variants.some(variant => String(variant.id) === String(form.elements.namedItem("id")?.value || "")) && FormController && productForm instanceof FormController && RerenderController && owner instanceof RerenderController &&
        W.__customMainAtcInit === true && typeof W.gmPurchase?.begin === "function" && typeof W.gmPurchase?.validatePooja === "function" && typeof W.gmPurchase?.isBusy === "function";
      return known && owned.length === 1 && customControls.length === 1 ? owned[0] : null;
    }
    return [...form.querySelectorAll("button")].find(button => /add to cart/i.test(button.textContent)) || form.querySelector('button[type="submit"]:not([name="checkout"])');
  };
  const policy = W.GM_PDP_PURCHASE_POLICY;
  const policyOwned = policy && String(policy.productId) === String(P.id) && ['direct','options','details','enquiry','unavailable','invalid'].includes(policy.purchasePolicy) && typeof policy.enquiryOnly === 'boolean';
  const quoteOnly = !!(policyOwned && policy.enquiryOnly && policy.purchasePolicy === 'enquiry');
  const quoteLabel = quoteOnly && typeof policy.labels?.price === 'string' ? policy.labels.price : 'Price on request';
  const enquiryLabel = quoteOnly && typeof policy.labels?.enquire === 'string' ? policy.labels.enquire : 'Enquire on WhatsApp';
  const quoteText = (key, fallback) => typeof policy?.labels?.[key] === "string" ? policy.labels[key] : fallback;
  const quoteFormOwned = form => !!(quoteOnly && form && form.getAttribute('id') && variantById(form.elements.namedItem('id')?.value) && form.closest('.product-info'));
  if (policy?.enquiryOnly === true && !quoteOnly) {D.documentElement.classList.remove('gm-pdp-wait');return;}
  if (!initialForm || (!nativeAtc(initialForm) && !quoteFormOwned(initialForm))) { D.documentElement.classList.remove("gm-pdp-wait"); return; }
  // Legacy weight/custom checkout controls keep their complete native contract.
  const initialOwner = initialForm.closest("product-rerender") || initialForm.closest(".product-info") || initialForm;
  if (initialOwner.querySelector(".product-custom-options,[data-gm-jaap-card]")) {D.documentElement.classList.remove("gm-pdp-wait");return;}
  let v0 = variantById(nativeId()) || variantById(W.GM_PDP_SELECTED) || variantById(new URL(location.href).searchParams.get("variant")) || P.variants.find((v) => v.available) || P.variants[0];
  if (!v0) { D.documentElement.classList.remove("gm-pdp-wait"); return; }
  let base = v0.price / 100, inStock = !!v0.available;
  const
    lab = specs["Lab named on listing"] || specs["Lab Name"] || "",
    repD = repM
      ? null
      : String(P.description || "")
          .replace(/<[^>]+>/g, " ")
          .match(
            /\b(Gemtrue|IGI|GIA|GRS|IIGJ|GII|IGL|GTL|AGL|SSEF|Gubelin|GemsMantra)\b[^.]{0,40}?\b(?:card|report|certificate)\b[^.]{0,30}?\b(?:numbered|no\.?|number)\s*([A-Z]*\d{5,})/i,
          ),
    hasReport = !!(repM || repD),
    report = repM ? repM[1] : repD ? repD[2] : null,
    repLab = repM ? repM[2].trim() : repD ? repD[1] : lab,
    heatRaw = specs.Treatment || "",
    heated = /heat|thermal/i.test(heatRaw) && !/no indication/i.test(heatRaw),
    heatTxt =
      !heatRaw || heatRaw === "-"
        ? "Per report"
        : /oiling only/i.test(heatRaw)
          ? "Minor oil (clarity enhancement)"
          : heatRaw,
    origin = specs.Origin && specs.Origin !== "-" ? specs.Origin : "",
    dims =
      specs["Dimension Type"] && specs["Dimension Type"] !== "-"
        ? specs["Dimension Type"].replace(/[*xX]/g, " \xD7 ")
        : "",
    shape = specs.Shape || "",
    high = base >= 1e5,
    GI = null,
    loc = (u) => String(u || "").replace(/^(?:https?:)?\/\/cdn\.shopify\.com\/s\/files\/\d+(?:\/\d+)+\/(files|products)\//, location.origin + "/cdn/shop/$1/"),
    media = GI
      ? GI.imgs
      : P.media.filter((m) => m.media_type === "image").map((m) => loc(m.src)),
    vids = P.media.filter((m) => m.media_type !== "image"),
    ritualV = pVals
      .slice(0, 2)
      .map((t, i) => ({
        name: /vedic/i.test(t) ? "Vedic pooja + film" : "Shudh energisation",
        sub: /vedic/i.test(t)
          ? "Your name & gotra \xB7 +2 days"
          : "Mantra-charged before dispatch",
        add: 0,
        days: /vedic/i.test(t) ? 2 : 0,
        tag: i === 0 ? "INCLUDED" : /vedic/i.test(t) ? "WITH FILM" : "",
      })),
    rituals = ritualV.length ? ritualV : [{name:"Selected product option",sub:"As selected below",add:0,days:0,tag:""}],
    certs = [{name:hasReport ? repLab : "See listing details",sub:"Existing report",add:0,days:0}],
    forms = [{name:"As selected below",sub:"Native product options",add:0,days:0}],
    FAV = {Shani:["Vrishabh","Mithun","Kanya","Tula","Makar","Kumbh"],Guru:["Mesh","Kark","Simha","Vrishchik","Dhanu","Meen"],Surya:["Mesh","Simha","Vrishchik","Dhanu"],Chandra:["Mesh","Kark","Vrishchik","Meen"],Mangal:["Mesh","Kark","Simha","Vrishchik","Dhanu","Meen"],Budh:["Vrishabh","Mithun","Kanya","Tula","Makar","Kumbh"],Shukra:["Vrishabh","Mithun","Kanya","Tula","Makar","Kumbh"]},
    LAG = [
      "Mesh",
      "Vrishabh",
      "Mithun",
      "Kark",
      "Simha",
      "Kanya",
      "Tula",
      "Vrishchik",
      "Dhanu",
      "Makar",
      "Kumbh",
      "Meen",
    ],
    S = {
    w: Math.max(0, wVals.indexOf(v0.options[wOpt])),
      view: 0,
      q: 0,
      lagna: null,
      r: Math.max(0, pVals.indexOf(v0.options[pOpt])),
      c: 0,
      f: 0,
      sat: -1,
      tab: 0,
      faq: -1,
      custom: !1,
      notified: !1,
    };
  let similar = [],
    fairSet = [],
    myRank = 1,
    tied = !1,
    simState = "loading",
    simAll = [],
    simRetry = null;
  const simCalc = () => {
    if (quoteOnly) {fairSet=[];myRank=0;tied=false;return;}
    fairSet = [{ h: handle, ct, p: base, ppc: base / ct, me: !0 }]
      .concat(similar.slice(0, 3))
      .sort((a, b) => a.ppc - b.ppc);
    myRank = fairSet.findIndex((x) => x.me) + 1;
    tied =
      fairSet.filter((x) => Math.round(x.ppc) === Math.round(base / ct)).length >
      1;
  };
  simCalc();
  /* similar stones load AFTER first paint (the page used to wait for 4 collection downloads before showing anything); the reduced list is kept in sessionStorage for 30 min so moving between stones is instant */
  const simReduce = (prods) =>
    prods
      .filter((x) => x && x.variants && x.variants.some((v) => v.available))
      .map((x) => {
        const c = num((x.title.match(/([\d.]+)\s*Carat/i) || [])[1]),
          p = +x.variants.find(v => v.available).price;
        return {
          h: x.handle,
          t: x.product_type || "",
          ct: c,
          p,
          img: (x.images[0] || {}).src,
          ppc: p / c,
        };
      })
      .filter((x) => x.ct && x.p > 0);
  const simLite = (items) =>
    items
      .filter(x => x && x.quote === false && ["direct","options","details"].includes(x.policy) && /^\d+$/.test(x.id || "") && /^[a-z0-9][a-z0-9-]*$/.test(x.h || "") && typeof x.p === "number" && Number.isFinite(x.p) && x.p > 0)
      .map((x) => {
        const c = num(((x.ti || "").match(/([\d.]+)\s*Carat/i) || [])[1]),
          p = (+x.p || 0) / 100;
        return {
          h: x.h,
          t: x.t || "",
          ct: c,
          p,
          img: x.img
            ? x.img.replace(/([?&])width=\d+&?/, "$1").replace(/[?&]$/, "")
            : null,
          ppc: p / c,
        };
      })
      .filter((x) => x.h && x.ct && x.p > 0);
  const simPick = (all) => {
    if (!Number.isFinite(ct) || ct <= 0 || !quoteOnly && (!Number.isFinite(base) || base <= 0)) return [];
    all = all.filter((x) => x.h !== handle && (!x.t || x.t === P.type));
    const sc = (x) => quoteOnly ? Math.abs(x.ct - ct) : Math.abs(Math.log(x.p / base)) + Math.abs(x.ct - ct) * 0.15;
    let pool = all.filter((x) => Math.abs(x.ct - ct) <= 1);
    if (pool.length < 4) pool = all.filter((x) => Math.abs(x.ct - ct) <= 2);
    if (pool.length < 4 || !inStock) pool = all;
    const sc2 = inStock || quoteOnly
      ? sc
      : (x) => Math.abs(Math.log(x.p / base)) + Math.abs(x.ct - ct) * 0.05;
    return pool.sort((a, b) => sc2(a) - sc2(b)).slice(0, 6);
  };
  const simApply = () => {
    if (disposed) return;
    if (buyPress || D.activeElement && (D.activeElement.tagName === "SELECT" || root?.contains(D.activeElement) || sticky?.contains(D.activeElement))) {
      if (simRetry !== null) return;
      const timer = setTimeout(() => {renderTimers.delete(timer);simRetry=null;if(!disposed)simApply();}, 1500);
      simRetry = timer;
      renderTimers.add(timer);
      return;
    }
    if(simRetry !== null){clearTimeout(simRetry);renderTimers.delete(simRetry);simRetry=null;}
    similar = simPick(simAll);
    simCalc();
    try {
      render();
    } catch (e) {}
  };
  const simLoad = async () => {
    if (disposed) return;
    try {
      const key = "gm-sim:v3-policy:" + (coll || "type:" + P.type);
      let all = null, policyItems = [];
      try {
        const c = JSON.parse(sessionStorage.getItem(key) || "null");
        if (c && c.policyVersion === "gm-purchase-v1" && c.currency === CUR && Date.now() - c.t < 18e5 && Array.isArray(c.items)) all = simLite(c.items);
      } catch {}
      if (!all) {
        if (coll) {
          /* compact list from templates/collection.gm-sim.liquid (~150 bytes a stone); products.json only if that view is missing */ all =
            [];
          let okv = !1;
          for (let n = 1; n <= 4; n++) {
            const t = await fetch(
              "/collections/" + coll + "?view=gm-sim&page=" + n,
            )
              .then((r) => (r.ok ? r.text() : ""))
              .catch(() => "");
            if (disposed) return;
          let j = null;
            try {
              j = JSON.parse(t);
            } catch (e) {}
            if (!j || j.policyVersion !== "gm-purchase-v1" || j.currency !== CUR || !Array.isArray(j.items) || j.page !== n || !Number.isInteger(j.pages) || j.pages < n || j.items.length > 250) break;
            okv = !0;
            policyItems = policyItems.concat(j.items);
            all = all.concat(simLite(j.items));
            if (n >= (+j.pages || 1)) break;
          }
          if (!okv) all = [];
        } else all = [];
        try {
          sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), policyVersion: "gm-purchase-v1", currency: CUR, items: policyItems }));
        } catch {}
      }
      if (disposed) return;
      simAll = all;
      similar = simPick(all);
    } catch {}
    if (disposed) return;
    simState = "done";
    simApply();
    if (W.__GMV2 && !disposed) W.__GMV2.similar = similar.length;
  };

  const css = `
.gmv2{--ink:#111113;--ink2:#3C3C43;--mut:#5E5E66;--line:#E7E7E4;--pearl:#F7F7F5;--plinth:#F5F5F3;--mid:#12151D;--mar:#5C0E1B;--gold:#7E5F27;--ok:#2F6B47;--amb:#94560A;font-family:Mukta,Jost,system-ui,sans-serif;color:var(--ink);font-size:15px;line-height:1.5;background:#fff;text-align:left}
.gmv2 *{box-sizing:border-box}.gmv2 button,.gmv2 p{white-space:normal}.gmv2 button{font-family:inherit;cursor:pointer;color:inherit}
.gmv2 .wrap{max-width:1240px;margin:0 auto;padding:0 16px}
.gmv2 .top{display:flex;flex-wrap:wrap;gap:0 56px;align-items:flex-start}
.gmv2 .gal{flex:1 1 520px;min-width:0}.gmv2 .info{flex:1 1 420px;min-width:0;display:flex;flex-direction:column;gap:12px;padding-top:6px}
@media(min-width:960px){.gmv2 .gal{position:sticky;top:110px}}
@media(min-width:960px) and (max-height:899px){html body #gmv2 .gal{position:static}}
.gmv2 .crumb{font-size:12px;color:var(--mut);padding:12px 0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.gmv2 .crumb a{color:var(--mut);text-decoration:none}
.gmv2 .stage{position:relative;aspect-ratio:1/1;background:var(--plinth);display:flex;align-items:center;justify-content:center;overflow:hidden}
.gmv2 .stage img{width:100%;height:100%;object-fit:contain;mix-blend-mode:multiply}
.gmv2 .chip{position:absolute;top:12px;left:12px;background:#fff;font-size:12px;letter-spacing:.08em;padding:6px 10px;font-family:Jost,sans-serif}
.gmv2 .live{position:absolute;top:8px;right:8px;min-height:44px;padding:0 12px;display:flex;align-items:center;gap:6px;background:#fff;font-size:13px;font-weight:600;text-decoration:none;color:var(--ink)}
@media(max-width:599px){html body #gmv2 .stage .live{top:52px;max-width:calc(100% - 20px)}}
.gmv2 .dot{width:8px;height:8px;border-radius:50%;background:var(--ok);display:inline-block}
.gmv2 .cap{position:absolute;left:12px;bottom:10px;font-size:13px;color:var(--ink2);background:rgba(255,255,255,.85);padding:2px 8px}
.gmv2 .sold{position:absolute;inset:0;background:rgba(255,255,255,.7);display:flex;align-items:center;justify-content:center}.gmv2 .sold span{background:var(--mid);color:#fff;padding:10px 16px;font-family:Jost,sans-serif;letter-spacing:.16em;font-size:14px}
.gmv2 .thumbs{display:grid;grid-template-columns:repeat(6,minmax(0,1fr));gap:6px;margin-top:6px}
.gmv2 .thumbs button{aspect-ratio:1/1;border:1px solid var(--line);background:var(--plinth);padding:0;display:flex;align-items:center;justify-content:center;font-size:12px;color:var(--ink2)}
.gmv2 .thumbs button.on{border:2px solid var(--ink)}.gmv2 .thumbs img{width:100%;height:100%;object-fit:contain;mix-blend-mode:multiply}
.gmv2 .eye{font-family:Jost,sans-serif;font-size:12px;letter-spacing:.18em;color:var(--gold)}
.gmv2 h1.t{margin:0;font-family:'Playfair Display',Georgia,serif;font-weight:400;font-size:clamp(26px,3vw,34px);line-height:1.15;letter-spacing:-.01em;color:var(--ink)}
.gmv2 h1.t em{color:var(--ok)}.gmv2 h1.t em.w{color:var(--mar)}
.gmv2 .spec{font-size:14px;color:var(--ink2)}
.gmv2 .price{display:flex;align-items:baseline;flex-wrap:wrap;gap:4px 12px}.gmv2 .price b{font-family:'Playfair Display',Georgia,serif;font-weight:500;font-size:32px}.gmv2 .price span{font-size:13px;color:var(--mut)}
.gmv2 .sub{font-size:14px;color:var(--ink2)}#gm-snap *{font-size:max(12px,1em)}#gm-snap .snap_emi_slogan_text,#gm-snap .snap-line{font-size:12px !important}.gmv2 .wgrid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:6px;max-height:240px;overflow:auto}
.gmv2 .cpn{font-size:14px;color:var(--ink2);background:#EEF5F0;padding:8px 10px}.gmv2 .cpn b{color:var(--ok)}.gmv2 .cpn span{font-size:12px;color:var(--mut)}
.gmv2 .rate{font-size:13px;color:var(--ink2);text-decoration:none;min-height:24px}.gmv2 .rate span{color:var(--gold);letter-spacing:1px}
.gmv2 a.buy{display:flex;align-items:center;justify-content:center;text-decoration:none}
.gmv2 .proof{display:flex;gap:12px;padding:12px;border:1px solid var(--line);background:var(--pearl)}
.gmv2 .badge{flex:none;width:28px;height:28px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:14px;background:var(--ok);color:#fff}.gmv2 .badge.q{background:#fff;color:var(--amb);border:1px solid var(--amb)}
.gmv2 .btns{display:flex;gap:8px;flex-wrap:wrap;margin-top:6px}
.gmv2 .ob{min-height:44px;padding:0 14px;display:inline-flex;align-items:center;border:1px solid var(--ink);background:#fff;font-size:13px;font-weight:600;text-decoration:none;color:var(--ink)}
.gmv2 .del{display:flex;gap:10px;align-items:center;font-size:14px;color:var(--ink2)}
.gmv2 .qs{border-top:1px solid var(--ink);margin-top:4px}.gmv2 .qrow{border-bottom:1px solid var(--line)}
.gmv2 .qbtn{width:100%;min-height:64px;border:0;background:none;display:flex;align-items:center;gap:12px;padding:12px 0;text-align:left}
.gmv2 .qbtn .tx{flex:1;display:flex;flex-direction:column}.gmv2 .qbtn .tx b{font-family:'Playfair Display',Georgia,serif;font-weight:400;font-size:18px}.gmv2 .qbtn .tx small{font-size:13px;color:var(--mut)}
.gmv2 .qbtn .pm{font-size:22px;color:var(--gold);width:20px;text-align:center}
.gmv2 .qbody{padding:0 0 16px 40px;font-size:14px;color:var(--ink2)}
.gmv2 .lg{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:6px;margin:8px 0}
.gmv2 .lg button,.gmv2 .opt{min-height:44px;border:1px solid #D4D4D0;background:#fff;font-size:13px}
.gmv2 .lg button.on,.gmv2 .opt.on{background:var(--mid);color:#fff;border-color:var(--mid)}
.gmv2 .verdict{padding:12px 14px;background:var(--pearl);margin:6px 0}.gmv2 .verdict b{font-family:'Playfair Display',Georgia,serif;font-weight:400;font-size:16px;display:block}
.gmv2 .bar{display:flex;align-items:center;gap:10px;font-size:13px;margin:6px 0}.gmv2 .bar i{flex:1;height:8px;background:#EFEFEC;position:relative}.gmv2 .bar i s{position:absolute;left:0;top:0;bottom:0;background:#C8CAD1}.gmv2 .bar.me{font-weight:700}.gmv2 .bar.me i s{background:var(--ok)}
.gmv2 .card{border:1px solid #D4D4D0;margin-top:6px}
.gmv2 .card .hd{padding:16px 16px 4px}.gmv2 .card .hd span{display:block;font-family:Jost,sans-serif;font-size:12px;letter-spacing:.14em;color:var(--gold)}.gmv2 .card .hd b{font-family:'Playfair Display',Georgia,serif;font-weight:400;font-size:21px}.gmv2 .card .hd b em{color:var(--mar)}
.gmv2 .ln{display:flex;justify-content:space-between;gap:12px;padding:10px 16px;border-bottom:1px solid #EFEFEC;font-size:14px}.gmv2 .ln span{color:var(--mut)}.gmv2 .ln b{text-align:right}
.gmv2 .lab{font-family:Jost,sans-serif;font-size:12px;letter-spacing:.12em;padding:14px 16px 8px;display:block}
.gmv2 .rit{display:flex;gap:8px;overflow-x:auto;padding:0 16px 4px}
.gmv2 .rit button{flex:none;width:150px;min-height:136px;padding:10px;border:1px solid #D4D4D0;background:#fff;display:flex;flex-direction:column;gap:4px;text-align:left}
.gmv2 .rit button.on{border-color:var(--mid);box-shadow:inset 0 0 0 1px var(--mid)}
.gmv2 .rit small{font-family:Jost,sans-serif;font-size:12px;letter-spacing:.06em;color:var(--gold);min-height:18px}.gmv2 .rit b{font-size:14px}.gmv2 .rit em{font-style:normal;font-size:12px;color:var(--mut)}.gmv2 .rit strong{font-family:'Playfair Display',Georgia,serif;font-weight:400;font-size:16px;margin-top:auto}
.gmv2 .kinds{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;padding:0 16px}.gmv2 .kind{min-height:112px;border:1px solid #D4D4D0;background:#fff;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;padding:10px 6px;color:var(--ink);font-family:inherit}.gmv2 .kind svg{width:30px;height:30px;stroke:currentColor;fill:none;stroke-width:1.2;margin-bottom:4px}.gmv2 .kind b{font-weight:600;font-size:14px}.gmv2 .kind small{font-size:12px;color:var(--mut);line-height:1.3;text-align:center}.gmv2 .kind.on{border-color:var(--ink);box-shadow:inset 0 0 0 1px var(--ink)}.gmv2 .metals{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:6px;padding:8px 16px 0}.gmv2 .ship svg{vertical-align:-4px;margin-right:6px}.gmv2 .ship{display:block;text-align:center;font-size:14px;color:var(--ink2);padding:10px 8px 0}.gmv2 .chg{width:100%;min-height:48px;border:0;border-top:1px solid #EFEFEC;background:none;font-size:14px;font-weight:600;color:var(--mar)}
.gmv2 .grid3{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:6px;padding:0 16px}.gmv2 .opt{min-height:58px;padding:6px 4px}.gmv2 .opt small{display:block;font-size:12px;color:var(--mut)}.gmv2 .opt.on small{color:#D9DBE2}
.gmv2 .opt[disabled]{background:var(--pearl);color:var(--mut);text-decoration:line-through;border-style:dashed;cursor:not-allowed}
.gmv2 .tot{display:flex;justify-content:space-between;align-items:baseline;padding:12px 16px 14px;border-top:1px solid #EFEFEC}.gmv2 .tot span{font-family:Jost,sans-serif;font-size:12px;letter-spacing:.14em}.gmv2 .tot b{font-family:'Playfair Display',Georgia,serif;font-weight:500;font-size:26px}
.gmv2 .buy{height:56px;border:0;background:var(--mar);color:#fff !important;font-family:Jost,sans-serif;font-size:15px;letter-spacing:.1em;width:100%}
.gmv2 .buy.dark{background:var(--mid)}
.gmv2 .gm-pair{display:grid;grid-template-columns:1fr 1fr;gap:10px}.gmv2 .gm-pair .buy{min-width:0;padding:0 8px;letter-spacing:.06em;white-space:nowrap;cursor:pointer}
.gmv2 .buy.gm-ghost{background:#fff;border:1.5px solid var(--mar);color:var(--mar) !important}
.gmv2 .buy.gm-bn{background:linear-gradient(135deg,#7d1d30,#4a0f1e)}
html body #gmv2 .qb{display:grid;grid-template-columns:1fr;gap:8px;margin:14px 0 4px}
.gmv2 .sp{min-height:52px;border:1px solid var(--ink);display:flex;align-items:center;justify-content:center;text-align:center;padding:0 12px;font-size:15px;font-weight:600;text-decoration:none;color:var(--ink)}
.gmv2 .trust{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));border-top:1px solid var(--line);border-bottom:1px solid var(--line)}.gmv2 .trust div{padding:12px 6px;text-align:center}.gmv2 .trust div+div{border-left:1px solid var(--line)}.gmv2 .trust b{display:block;font-family:'Playfair Display',Georgia,serif;font-weight:400;font-size:17px}.gmv2 .trust span{font-size:12px;color:var(--mut)}
.gmv2 .pay{display:flex;justify-content:center;gap:14px;flex-wrap:wrap;font-family:Jost,sans-serif;font-size:12px;letter-spacing:.08em;color:var(--mut)}
.gmv2 .det{max-width:900px;margin:0 auto;padding:0 16px}
.gmv2 .h{font-family:Jost,sans-serif;font-size:12px;letter-spacing:.16em;color:var(--gold);margin:44px 0 12px;display:block}
.gmv2 .box{display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));gap:8px}.gmv2 .box div{padding:14px 12px;background:var(--pearl)}.gmv2 .box b{display:block;font-family:'Playfair Display',Georgia,serif;font-weight:400;font-size:16px}.gmv2 .box span{font-size:13px;color:var(--ink2)}
.gmv2 .size{height:170px;background:var(--pearl);display:flex;align-items:center;justify-content:center;gap:40px;font-size:13px;color:var(--ink2);text-align:center}
.gmv2 .tabs{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));border-bottom:1px solid var(--line)}.gmv2 .tabs button{min-height:48px;border:0;background:none;font-size:14px;color:var(--mut);border-bottom:2px solid transparent}.gmv2 .tabs button.on{color:var(--ink);font-weight:600;border-color:var(--ink)}
.gmv2 .row{display:flex;justify-content:space-between;gap:14px;padding:11px 0;border-bottom:1px solid #EFEFEC;font-size:14px}.gmv2 .row span{color:var(--mut)}.gmv2 .row b{text-align:right}
.gmv2 .sim{display:flex;gap:12px;overflow-x:auto;padding-bottom:4px}.gmv2 .sim a{flex:none;width:170px;text-decoration:none;color:var(--ink)}.gmv2 .sim .im{height:170px;background:var(--plinth)}.gmv2 .sim img{width:100%;height:100%;object-fit:contain;mix-blend-mode:multiply}.gmv2 .sim b{display:block;font-family:'Playfair Display',Georgia,serif;font-weight:400;font-size:17px;margin-top:6px}.gmv2 .sim span{font-size:13px;color:var(--ink2)}
.gmv2 .rev{display:flex;gap:16px;align-items:center;padding:14px;border:1px solid var(--line)}.gmv2 .rev b{font-family:'Playfair Display',Georgia,serif;font-size:36px;font-weight:400;line-height:1}
.gmv2 .note{padding:14px;background:var(--pearl);font-size:14px;color:var(--ink2);margin-top:8px}
.gmv2 .gmfaq button{width:100%;min-height:56px;border:0;border-bottom:1px solid var(--line);background:none;display:flex;justify-content:space-between;align-items:center;gap:14px;text-align:left;font-size:15px;font-weight:600;padding:12px 0}.gmv2 .gmfaq p{margin:0;padding:12px 0 14px;font-size:14px;color:var(--ink2);border-bottom:1px solid var(--line)}
.gmv2 .fine{font-size:12px;color:var(--mut);line-height:1.6;margin:28px 0 40px}
.gmv2 .pk{background:var(--mid);color:#F2F2F0;padding:30px 22px;margin-top:44px}.gmv2 .pk .tg{display:inline-block;font-size:12px;border:1px solid #D8C49A;color:#D8C49A;padding:3px 8px;margin-left:8px}.gmv2 .pk h2{font-family:'Playfair Display',Georgia,serif;font-weight:400;font-size:26px;margin:10px 0;color:#F2F2F0}.gmv2 .pk div{display:flex;gap:14px;padding:12px 0;border-top:1px solid #343846}.gmv2 .pk i{font-family:'Playfair Display',Georgia,serif;color:#D8C49A;font-style:normal;width:22px}.gmv2 .pk small{display:block;color:#C8CAD1;font-size:13px}
.gmv2-sticky{position:fixed;left:0;right:0;bottom:0;z-index:60;background:#fff;border-top:1px solid #E7E7E4;padding:10px 12px 14px 16px;display:flex;align-items:center;gap:10px;font-family:Mukta,system-ui,sans-serif}
.gmv2-sticky .p{flex:1;min-width:0}.gmv2-sticky .p b{display:block;font-family:'Playfair Display',Georgia,serif;font-weight:500;font-size:20px;color:#111113}.gmv2-sticky .p span{font-size:12px;color:#5E5E66;white-space:nowrap}
.gmv2-sticky a{flex:none;width:48px;height:48px;border:1px solid #111113;display:flex;align-items:center;justify-content:center}
.gmv2-sticky .gm-quote-enquiry{width:auto;min-width:150px;min-height:50px;height:auto;padding:8px 12px;background:#5C0E1B;color:#fff;text-decoration:none;text-align:center}.gmv2-sticky button{flex:none;min-width:150px;height:50px;border:0;background:#5C0E1B;color:#fff;font-family:Jost,sans-serif;font-size:14px;letter-spacing:.1em}
@media(min-width:960px){.gmv2-sticky{left:0;right:0;top:0;bottom:auto;width:auto;z-index:70;gap:16px;padding:12px 48px;background:#FFFAF5;border:0;border-bottom:1px solid #DFDAD4;box-shadow:0 6px 18px rgba(17,17,19,.06);transform:translateY(-100%);opacity:0;visibility:hidden;transition:transform .25s ease,opacity .25s ease,visibility .25s}html.gm-sb .gmv2-sticky{transform:none;opacity:1;visibility:visible}}
.gmv2-sticky .th{display:none;flex:none;width:48px;height:48px;object-fit:cover;border-radius:8px;background:#F2F2F0}
.gmv2-sticky .p .tt{display:none;font-family:'Playfair Display',Georgia,serif;font-size:16px;line-height:1.25;color:#111113;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.gmv2-sticky .gm-ghost,.gmv2-sticky .gm-bn{flex:1 1 0;min-width:0;height:50px;padding:0 8px;font-family:Jost,sans-serif;font-size:12.5px;letter-spacing:.04em;white-space:nowrap;cursor:pointer}
.gmv2-sticky .gm-ghost{background:#fff;border:1.5px solid #5C0E1B;color:#5C0E1B}
.gmv2-sticky .gm-bn{background:linear-gradient(135deg,#7d1d30,#4a0f1e);border:0;color:#fff}
.gmv2-sticky .p:has(.tt){flex:0 0 auto;min-width:0}.gmv2-sticky .p:has(.tt) b{font-size:18px}
.gmv2-sticky .gm-off{display:none}
@media(max-width:959px){html.gm-sb .qr_wa_icon.qr_wa_icon,html.gm-sb #call-now-button,html.gm-sb #zsiq_float{bottom:128px!important;transition:bottom .25s}}
@media(max-width:959px){.gmv2-sticky.gm-has-off{flex-wrap:wrap;padding-top:0}.gmv2-sticky .gm-off{display:block;flex:0 0 calc(100% + 28px);box-sizing:border-box;margin:0 -12px 8px -16px;padding:7px 12px;background:#3f9d43;color:#fff;font:600 13px/1.3 Jost,system-ui,sans-serif;text-align:center}.gmv2-sticky.gm-has-off .p:has(.tt){margin-top:2px}}
@media(max-width:959px){.gmv2-sticky{transition:transform .25s ease,opacity .25s ease,visibility .25s;transform:translateY(110%);opacity:0;visibility:hidden}html.gm-sb .gmv2-sticky{transform:none;opacity:1;visibility:visible}}
@media(min-width:960px){.gmv2-sticky .th{display:block;width:56px;height:56px}.gmv2-sticky .p:has(.tt){flex:1 1 0;min-width:0;display:flex;flex-direction:column;gap:2px}.gmv2-sticky .p:has(.tt) b{font-size:20px}.gmv2-sticky .p .tt{display:block}.gmv2-sticky .gm-ghost,.gmv2-sticky .gm-bn{flex:none;min-width:170px;padding:0 20px;font-size:14px;letter-spacing:.08em}}
`;
  if (!D.getElementById("gmv2-font")) {
    const l = D.createElement("link");
    ((l.id = "gmv2-font"),
      (l.rel = "stylesheet"),
      (l.href =
        "https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;1,400&family=Mukta:wght@400;600;700&family=Jost:wght@400;500&display=swap"),
      D.head.appendChild(l));
  }
  let st = D.getElementById("gmv2-css");
  (st ||
    ((st = D.createElement("style")),
    (st.id = "gmv2-css"),
    D.head.appendChild(st)),
    (st.textContent = css + ` .gm-native-purchase{padding:16px}.gm-native-purchase .product{display:block!important;grid-template-columns:1fr!important}.gm-native-purchase product-gallery,.gm-native-purchase .product-content-below-gallery{display:none!important}.gm-native-purchase .product-info{position:static!important;width:auto!important;max-width:none!important}.gm-native-purchase [data-gm-v21-hide]{display:none!important}.gm-service-note{padding:0 16px 12px;font-size:14px;color:#5E5E66}.gm-native-purchase button:focus-visible,.gm-native-purchase input:focus-visible,.gm-native-purchase select:focus-visible{outline:2px solid #5C0E1B;outline-offset:3px}`));
  const secs = [...D.querySelectorAll('[id^="shopify-section-template--"]')],
    main = secs.find((s) => s.querySelector("h1")) || secs[0];
  if (!main || !main.contains(initialForm)) { D.documentElement.classList.remove("gm-pdp-wait"); return; }
  const keep = D.createElement("div");
  ((keep.id = "gmv2-keep"),
    (keep.style.cssText =
      "display:none"));
  let pform = initialForm,
    atcBtn = nativeAtc(pform),
    BOOK = null,
    snapBox = main.querySelector("#sm-widget-btn"),
    wearBlk = (main.querySelector(".wear-choice") || {}).parentElement || null;
  let nativeHost = pform.closest("product-rerender") || pform.closest(".product-info") || pform.closest("product-form") || pform;
  // Do not disconnect a native controller after the customer has started using it.
  if (pform.dataset.gmVariantPending === "true" || pform.dataset.gmSubmitting === "true" ||
      W.gmPurchase?.isBusy?.() || nativeHost.contains(D.activeElement) ||
      [...initialPickerGenerations].some(([picker, generation]) => typeof generation === "number" && picker._gmVariantGeneration !== generation)) {
    D.documentElement.classList.remove("gm-pdp-wait");
    return;
  }
  const nativeHostId = nativeHost.getAttribute("id"), nativeFormId = pform.getAttribute("id"), originalChildren = [...main.childNodes];
  let root = null, sticky = null, disposed = false, nativeObserver = null, buyPress = null;
  const ownedListeners = [], renderTimers = new Set();
  const listen = (target, type, callback, options) => {target.addEventListener(type, callback, options);ownedListeners.push([target, type, callback, options]);};
  const scheduleRender = () => {if(disposed)return;const timer=setTimeout(()=>{renderTimers.delete(timer);if(!disposed)render();},80);renderTimers.add(timer);};
  const initialNativeHost = nativeHost, nativeOrigin = {parent:nativeHost.parentNode,next:nativeHost.nextSibling}, styleSnapshots = new Map(), idSnapshots = new Map();
  const setNativeStyle = (el,prop,value) => {if(!styleSnapshots.has(el))styleSnapshots.set(el,el.getAttribute("style"));el.style[prop]=value;};
  const rollback = () => {
    if (disposed) return;
    const focused = D.activeElement, focusWasNative = nativeHost?.contains(focused);
    disposed = true;
    buyPress = null;
    nativeObserver?.disconnect();
    ownedListeners.forEach(([target,type,callback,options])=>target.removeEventListener(type,callback,options));
    renderTimers.forEach(timer=>clearTimeout(timer));
    renderTimers.clear();
    if (nativeHost?.isConnected && !keep.contains(nativeHost)) keep.appendChild(nativeHost);
    root?.remove(); sticky?.remove();
    for (const node of originalChildren) if (node !== keep) main.appendChild(node === initialNativeHost ? nativeHost : node);
    if (nativeOrigin.parent !== main) nativeOrigin.parent.insertBefore(nativeHost, nativeOrigin.next?.parentNode === nativeOrigin.parent ? nativeOrigin.next : null);
    styleSnapshots.forEach((style,el)=>{if(style===null)el.removeAttribute("style");else el.setAttribute("style",style);});
    idSnapshots.forEach((id,el)=>{if(id===null)el.removeAttribute("id");else el.setAttribute("id",id);});
    keep.remove();
    main.querySelectorAll("[data-gm-v21-hide]").forEach(el => {el.style.display = el.dataset.gmV21Display || "";delete el.dataset.gmV21Hide;delete el.dataset.gmV21Display;});
    D.documentElement.classList.remove("gm-pdp-ready","gm-pdp-wait","gm-sb");
    if (focusWasNative && focused.isConnected) focused.focus({preventScroll:true});
  };
  W.__gmV21Rollback = rollback;
  const adoptNative = () => {
    if (disposed) return null;
    const live = D.forms.namedItem(nativeFormId) || (pform?.isConnected ? pform : null);
    if (live) {
      pform = live;
      atcBtn = nativeAtc(live);
      nativeHost = (nativeHostId && D.getElementById(nativeHostId)) || live.closest("product-rerender") || live.closest(".product-info") || live.closest("product-form") || live;
      wearBlk = (nativeHost.querySelector(".wear-choice") || {}).parentElement || null;
    }
    const purchase = nativeHost.querySelector(".product-info");
    if (purchase) [...purchase.querySelectorAll(".product-info__block-item")].forEach(block => {
      const useful = block.querySelector('form[action*="/cart/add"],variant-picker,.np-pe,.np-cert,.wear-choice,[data-gm-pooja-fields],quantity-selector,[data-gm-addon-card],input,select,textarea,button');
      if (!useful && !block.hasAttribute("data-gm-v21-hide")) {block.dataset.gmV21Hide="true";block.dataset.gmV21Display=block.style.display;setNativeStyle(block,"display","none");}
    });
    if (wearBlk && !wearBlk.getAttribute("id")) {idSnapshots.set(wearBlk,null);wearBlk.id = "gm-wear";}
    return live;
  };
  const setAmt = (it) => {
      if (it.dataset.settingAmount) return it.dataset.settingAmount;
      const m = ((it.querySelector("p") || {}).textContent || "").match(
        /₹\s?[\d,]+/,
      );
      return m ? m[0].replace(/\s/g, "") : "";
    },
    wearF = () => {
      if (!wearBlk) return null;
      const ws = wearBlk.querySelector(".wear-choice .design-item.selected"),
        wv = ws ? ws.dataset.value : "loose-gemstone";
      if (/loose/i.test(wv)) return { name: "Loose", add: 0, days: 0 };
      const vis = (e) => {
          for (let x = e; x && x !== wearBlk; x = x.parentElement)
            if (getComputedStyle(x).display === "none") return !1;
          return !0;
        },
        ms = [
          ...wearBlk.querySelectorAll(".metal-options .design-item.selected"),
        ].find(vis),
        ds =
          wearBlk.__des && wearBlk.contains(wearBlk.__des)
            ? wearBlk.__des
            : null,
        amt = ds ? num(setAmt(ds).replace(/,/g, "")) : 0,
        adv = !!ds && ds.dataset.settingAdvance === "true";
      return {
        name:
          (ms ? ms.dataset.value + " " : "") +
          ((ws.querySelector("p") || ws).textContent.trim() || wv) +
          (ds
            ? " \xB7 " + ds.dataset.value + (adv ? " (advance)" : "")
            : " \xB7 choose a design"),
        add: amt || 0,
        days: 18,
        adv,
      };
    },
    wearOK = () => {
      if (!wearBlk) return !0;
      const ws = wearBlk.querySelector(".wear-choice .design-item.selected");
      return !ws || /loose/i.test(ws.dataset.value || "")
        ? !0
        : wearBlk.__des && wearBlk.contains(wearBlk.__des)
          ? [...wearBlk.querySelectorAll("select")]
              .filter((x) => x.offsetParent !== null)
              .every((x) => x.value && !/^select/i.test(x.value))
          : !1;
    };
  (wearBlk &&
    !wearBlk.__gm &&
    ((wearBlk.__gm = 1),
    listen(wearBlk,
      "click",
      (e) => {
        const t = e.target.closest(".design-item");
        t &&
          (t.closest(".design-options")
            ? (wearBlk.__des = t)
            : (wearBlk.__des = null));
      },
      !0,
    ),
    listen(wearBlk,"click", (e) => {
      const t = e.target;
      if (t.closest && t.closest("select,option,input,label,textarea")) return;
      scheduleRender();
    }),
    listen(wearBlk,"change", scheduleRender)),
    main.appendChild(keep),
    originalChildren.forEach((node) => keep.appendChild(node)),
    main.insertAdjacentHTML("afterbegin", '<div class="gmv2" id="gmv2"></div>'));
  root = D.getElementById("gmv2");
  root.classList.toggle("gm-sold", !inStock && !quoteOnly);
  sticky = D.querySelector(".gmv2-sticky");
  (sticky ||
    ((sticky = D.createElement("div")),
    (sticky.className = "gmv2-sticky"),
    D.body.appendChild(sticky)),
    [...D.querySelectorAll("body *")].forEach((e) => {
      if (
        e.closest(".gmv2-sticky") ||
        e.closest("#gmv2") ||
        W.getComputedStyle(e).position !== "fixed"
      )
        return;
      const r = e.getBoundingClientRect();
      r.width < 160 &&
        r.height < 160 &&
        r.top > W.innerHeight * 0.4 &&
        W.innerWidth < 960 &&
        setNativeStyle(e, "bottom", W.GM_PDP_STICKY_OFFER ? "128px" : "92px");
    }),
    D.querySelectorAll(
      '[class*="sticky-atc"],[class*="sticky_atc"],.np-sticky',
    ).forEach((e) => setNativeStyle(e, "display", "none")));
  const DAY = 864e5;
  function sats(lead) {
    const t = new Date();
    t.setHours(0, 0, 0, 0);
    const min = new Date(t.getTime() + Math.max(1, lead) * DAY),
      add = (dow - min.getDay() + 7) % 7,
      first = new Date(min.getTime() + add * DAY);
    return [0, 1, 2, 3, 4, 5].map((k) => ({
      d: new Date(first.getTime() + k * 7 * DAY),
      ok: !0,
    }));
  }
  const dS = (d) =>
      d.toLocaleDateString("en-IN", {
        weekday: "short",
        day: "numeric",
        month: "short",
      }),
    esc = (s) =>
      String(s).replace(
        /[&<>"]/g,
        (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c],
      );
  const quoteAction = (slot) => {
    const selected = variantById(nativeId());
    if (!selected || !quoteFormOwned(pform) || pform.dataset.gmVariantPending === 'true' || pform.dataset.gmVariantInvalid === 'true') return '<span role="status">'+esc(quoteText("pending", "Choose a valid selection to enquire."))+'</span>';
    const selectedUrl = new URL('/products/'+handle, location.origin);selectedUrl.searchParams.set('variant', String(selected.id));
    const message = 'Please confirm the price, availability and report for '+P.title+' — '+selected.title+' ('+(selected.sku || selected.id)+'). '+selectedUrl.href;
    return '<a id="gm-quote-'+slot+'" data-gm-variant-id="'+selected.id+'" class="buy dark gm-quote-enquiry" target="_blank" rel="noopener" href="'+esc(wa(message))+'" aria-label="'+esc(enquiryLabel+': '+P.title+' — '+selected.title)+'">'+esc(enquiryLabel)+' <span aria-hidden="true">↗</span></a>';
  };
  function render() {
    if (disposed) return;
    const focused = D.activeElement, selection = focused && "selectionStart" in focused ? [focused.selectionStart, focused.selectionEnd] : null;
    adoptNative();
    if (pform?.dataset.gmVariantPending === "true" || pform?.dataset.gmSubmitting === "true") {if(quoteOnly) [root,sticky].forEach(owner=>owner?.querySelectorAll(".gm-quote-enquiry").forEach(link=>{link.removeAttribute("href");link.setAttribute("aria-disabled","true");link.setAttribute("aria-busy","true");link.setAttribute("tabindex","0");}));root.querySelectorAll("[data-buy]").forEach(b=>{b.disabled=true;b.setAttribute("aria-busy","true");});const status=root.querySelector("[data-gm-v21-status]");if(status)status.textContent=pform.dataset.gmSubmitting === "true" ? "Updating cart…" : "Updating selection…";return;}
    BOOK = (() => {
      const m = ((atcBtn && atcBtn.textContent) || "").match(
        /booking amount[^0-9₹]*₹?\s?([\d,]+)/i,
      );
      return m && !P.options.some(o => /weight/i.test(o.name || o)) ? { amt: +m[1].replace(/,/g, "") } : null;
    })();
    if (nativeHost.isConnected && !keep.contains(nativeHost)) keep.appendChild(nativeHost);
    v0 = variantById(nativeId());
    base = v0 ? v0.price / 100 : NaN;
    inStock = !!(v0 && v0.available && atcBtn && !atcBtn.disabled && pform?.isConnected && pform.dataset.gmVariantPending !== "true" && pform.dataset.gmVariantInvalid !== "true");
    root.classList.toggle("gm-sold", !inStock && !quoteOnly);
    root.classList.toggle("gm-quote", quoteOnly);
    if(v0) {S.w=Math.max(0,wVals.indexOf(v0.options[wOpt]));S.r=Math.max(0,pVals.indexOf(v0.options[pOpt]));}
    S.c=0;S.f=0;
    const weightSelection = gmWeightSelection(P.options, v0);
    if (weightSelection.hasOption) {
      ct = weightSelection.selected ? weightSelection.selected.carat : NaN;
      ratti = weightSelection.selected ? weightSelection.selected.ratti : NaN;
    }
    const weightLabel = Number.isFinite(ratti) ? ratti.toFixed(1) + " ratti" : Number.isFinite(ct) ? ct.toFixed(2) + " ct" : "Weight on request";
    const weightDetails = [Number.isFinite(ct) && ct.toFixed(2) + " ct", Number.isFinite(ratti) && ratti.toFixed(1) + " ratti"].filter(Boolean).join(" · ") || "Weight on request";
    if (simState === "done") similar = simPick(simAll);
    simCalc();
    const r = rituals[S.r] || rituals[0],
      c = certs[S.c],
      f = wearF() || forms[S.f],
      total = base,
      days = r.days + c.days + f.days,
      lead = 4 + days,
      list = sats(lead),
      earliest = list.findIndex((x) => x.ok),
      si =
        S.sat >= 0 && list[S.sat] && list[S.sat].ok
          ? S.sat
          : Math.max(0, earliest),
      sat = list[si].d,
      t = new Date();
    t.setHours(0, 0, 0, 0);
    const ob = new Date(sat.getTime() - lead * DAY),
      dl = new Date(sat.getTime() - DAY),
      orderTxt =
        ob.getTime() <= t.getTime() ? "Order today" : "Order by " + dS(ob),
      ppc = base / ct,
      imgs = media.length ? media : [],
      lbl = (u) =>
        GI && GI.imgs.indexOf(u) > -1
          ? GI.lbls[GI.imgs.indexOf(u)]
          : /front/i.test(u)
            ? "Front"
            : /back/i.test(u)
              ? "Back"
              : /hand|finger/i.test(u)
                ? "On hand"
                : /cert|report|card/i.test(u)
                  ? "On its report"
                  : "View",
      isFilm = S.view === 99,
      cur = imgs[S.view] || imgs[0],
      fav = FAV[planet],
      good = fav && S.lagna && fav.includes(S.lagna),
      titleA =
        weightLabel +
        " " +
        (origin && /lanka|ceylon/i.test(origin)
          ? "Ceylon "
          : origin
            ? origin.split(" ")[0] + " "
            : "") +
        gName +
        ",",
      titleB = quoteOnly ? quoteText("title", "price and availability on request.") : inStock
        ? heated
          ? "heat-treated, disclosed."
          : /no indication/i.test(heatRaw)
            ? "no indication of heat."
            : /oil/i.test(heatRaw)
              ? "minor oil, disclosed."
              : /cultur/i.test(heatRaw) ||
                  /south sea|cultured|freshwater/i.test(P.title)
                ? "cultured; see report details."
                : "see report details."
        : "unavailable in this selection.",
      qs = [
        {
          q: "Report details",
          s: hasReport
            ? repLab + " " + report + " \xB7 listed report details"
            : "Ask when report details will be available",
          ok: false,
        },
        {
          q: "Is it right for me?",
          s: fav
            ? S.lagna
              ? S.lagna +
                " lagna: " +
                (good ? "traditionally favourable" : "check your kundli first")
              : "Check your lagna in 10 seconds"
            : "Ask a specialist about suitability",
          ok: !!good,
        },
        {
          q: "Compare product details", s: (!quoteOnly && Number.isFinite(ppc) && ct > 0 ? fmt(ppc) + "/ct · " : "") + "Compare weight, treatment, origin and report details" + (!Number.isFinite(ct) || ct <= 0 ? " · Carat comparison unavailable for this selection" : "") + (simState === "loading" ? " · Loading similar stones…" : ""), ok: false,
        },
      ];
    let h =
      '<div class="wrap"><div class="crumb"><a href="/">Home</a> \u203A <a href="/collections/' +
      (coll || "all") +
      '">' +
      gName +
      "</a> \u203A " +
      esc((v0 && v0.sku) || P.title.split(/[–-]/)[0].trim() || "") +
      '</div><div class="top"><div class="gal">';
    if (
      ((h +=
        '<div class="stage">' +
        (isFilm && film
          ? '<iframe src="' +
            film +
            '?autoplay=true&muted=true&loop=true" style="border:0;width:100%;height:100%" allow="autoplay; encrypted-media" title="360 film"></iframe>'
          : cur && cur.startsWith("data:")
            ? '<img src="' + cur + '" alt="' + esc(P.title) + '">'
            : cur
              ? '<img src="' +
                cur +
                '&width=900" srcset="' +
                cur +
                "&width=600 600w, " +
                cur +
                "&width=900 900w, " +
                cur +
                '&width=1300 1300w" sizes="(min-width:960px) 600px, 650px" crossorigin="anonymous" alt="' +
                esc(P.title) +
                '">'
              : "") +
        '<span class="chip">' +
        (weightSelection.multiple ? "CHOOSE YOUR WEIGHT" : "GEMSTONE DETAILS") +
        '</span><a class="live" target="_blank" rel="noopener" href="' +
        wa(
          "I want a live video of " +
            ((v0 && v0.sku) || P.title.split(/[–-]/)[0].trim()),
        ) +
        '"><span class="dot"></span>Request video on WhatsApp <span role="img" aria-label="Opens in a new window">↗</span></a><span class="cap">' +
        (isFilm
          ? "360\xB0 film"
          : imgs.length ? lbl(cur || "") + " \xB7 " + (Math.min(S.view,imgs.length-1) + 1) + " / " + imgs.length : "Photo details on request") +
        "</span>" +
        (inStock || quoteOnly
          ? ""
          : '<div class="sold"><span>UNAVAILABLE IN THIS SELECTION</span></div>') +
        "</div>"),
      (h +=
        '<div class="thumbs">' +
        imgs
          .slice(0, 5)
          .map(
            (u, i) =>
              '<button data-v="' +
              i +
              '" class="' +
              (i === S.view ? "on" : "") +
              '" aria-label="View ' +
              (i + 1) +
              '"><img src="' +
              u +
              '&width=200" alt=""></button>',
          )
          .join("") +
        (film
          ? '<button data-v="99" class="' +
            (isFilm ? "on" : "") +
            '" aria-label="360 film">\u25B6 Film</button>'
          : "") +
        "</div></div>"),
      (h +=
        '<div class="info"><div class="eye">' +
        gName.toUpperCase() +
        " \xB7 " +
        planet.toUpperCase() +
        " \xB7 " +
        esc((v0 && v0.sku) || P.title.split(/[–-]/)[0].trim() || "") +
        "</div>"),
      (h +=
        '<h1 class="t">' +
        esc(P.title) + // the product's own Shopify title; the generated "weight origin stone, see report details / unavailable in this selection." heading is no longer used
        "</h1>"),
      (h +=
        '<div class="spec">' +
        [
          weightDetails,
          shape,
          origin,
          dims && dims.split(" \xD7 ").slice(0, 2).join(" \xD7 ") + " mm",
        ]
          .filter(Boolean)
        .map(esc).join(" \xB7 ") +
        "</div>"),
      (h += '<a class="rate" href="/pages/customer-reviews">' + (LOOX ? esc(LOOX.avg) + " / 5 · " + esc(LOOX.n) + " store reviews" : "Read customer reviews") + "</a>"),
      false &&
      (h +=
          '<span class="lab" style="padding:4px 0 0">CHOOSE YOUR RATTI \xB7 stone hand-picked to this weight</span><div class="wgrid">' +
          wVals
            .map((x, i) => {
              const vv = vFor(0, i);
              return (
                '<button class="opt ' +
                (i === S.w ? "on" : "") +
                '" data-w="' +
                i +
                '" ' +
                (vv && vv.available ? "" : "disabled") +
                ">" +
                esc((x.match(/[\d.]+\s*ratti/i) || [x])[0]) +
                "<small>" +
                (!quoteOnly && vv ? fmt(vv.price / 100) : "") +
                "</small></button>"
              );
            })
            .join("") +
          "</div>"),
      (h +=
        '<div class="price"><b>' +
        (quoteOnly ? esc(quoteLabel) : fmt(inStock ? total : base)) +
        "</b><span>" + (quoteOnly ? esc(quoteText("details", "Confirm the exact selection, price and availability with our team")) : "incl. taxes") +
        (!quoteOnly && Number.isFinite(ppc) && ct > 0 ? " · " + fmt(ppc) + "/ct" : "") +
        "</span></div>"),
      !quoteOnly && inStock &&
        (h +=
          '<div id="gm-snap"></div>' +
        (CUR === "INR"
            ? '<div class="sub">UPI, cards, Snapmint EMI, COD on eligible orders</div>'
            : '<div class="sub">International cards accepted \xB7 insured shipping</div>')),
      !quoteOnly && !inStock &&
        (h +=
          '<div class="qb"><button class="buy dark" data-n="1">' +
          (S.notified
            ? "OPEN WHATSAPP AGAIN"
            : "NOTIFY ME ABOUT A SIMILAR " + gName.toUpperCase()) +
          "</button>" +
          (similar.length
            ? '<a class="qbs" href="#gm-sim">See ' +
              similar.length +
              " closest " +
              gName +
              " in stock \u2193</a>"
            : "") +
          "</div>"),
      !quoteOnly && inStock &&
        (h +=
          '<div class="qb">' +
          (BOOK
            ? '<button class="buy" data-buy="1">PAY BOOKING AMOUNT \xB7 ' + fmt(BOOK.amt) + "</button>"
            : '<div class="gm-pair"><button class="buy gm-ghost" data-buy="1">ADD TO CART</button><button class="buy gm-bn" data-buynow="1">BUY NOW</button></div>') +
          '<a class="qb2" href="#gm-cfg">Choose product options and paid services \u2193</a></div>'),
      quoteOnly && (h += '<div class="qb">'+quoteAction('hero')+'</div>'),
      (h +=
        '<div class="proof"><span class="badge ' +
        "q" +
        '">' +
        "?" +
        "</span><div><b>" +
        (hasReport
          ? esc(repLab) + " report " + report
          : "Report number on request") +
        '</b><div class="sub">' +
        (hasReport
          ? esc(
              weightDetails +
                (origin ? ", " + origin : "") +
                ", " +
                heatTxt.toLowerCase() +
                ". Check the number on the lab's site.",
            )
          : "Ask the team to confirm the report details, viewing options and when they will be available.") +
        '</div><div class="btns"><a class="ob" target="_blank" rel="noopener" href="' +
        (hasReport && /gemtrue/i.test(repLab)
          ? "https://gemtrue.in/verify_report.php?report_no=" + report
          : wa(
              "Please send the lab report number for " +
                ((v0 && v0.sku) || P.title.split(/[–-]/)[0].trim()),
            )) +
        '">' +
        (hasReport && /gemtrue/i.test(repLab)
          ? "Verify on " + esc(repLab)
          : hasReport ? "Request " + esc(repLab) + " report on WhatsApp" : "Request report on WhatsApp") +
        '<span role="img" aria-label="Opens in a new window"> ↗</span></a><a class="ob" target="_blank" rel="noopener" href="' +
        wa(
          "I want a live video of " +
            ((v0 && v0.sku) || P.title.split(/[–-]/)[0].trim()) +
            " (" +
            weightLabel +
            " " +
            gName +
            ", " +
            (quoteOnly ? "price on request" : fmt(base)) +
            ")",
        ) +
        '">Request video call on WhatsApp <span role="img" aria-label="Opens in a new window">↗</span></a></div></div></div>'),
      inStock &&
        (h +=
          '<div class="del"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#7E5F27" stroke-width="1.5"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg><span>' +
          "Delivery estimate and service timing confirmed at checkout" +
          "</span></div>"),
      (h +=
        '<div class="qs">' +
        qs
          .map((x, i) => {
            const open = S.q === i;
            let b = "";
            return (
              open &&
                (i === 0 &&
                  (b =
                    '<div class="qbody">' +
                    (hasReport
                      ? esc(repLab) +
                        " is named on this listing. Verify the report with the issuer and ask to see the exact stone beside its report before paying."
                      : "This listing does not show a report number. Ask the team what evidence will be available and when.") +
                    "</div>"),
                i === 1 &&
                  (b =
                    '<div class="qbody" style="padding-left:0">' +
                    (fav
                      ? '<div>Choose your lagna.</div><div class="lg">' +
                        LAG.map(
                          (l) =>
                            '<button data-l="' +
                            l +
                            '" class="' +
                            (l === S.lagna ? "on" : "") +
                            '">' +
                            l +
                            "</button>",
                        ).join("") +
                        "</div>" +
                        (S.lagna
                          ? '<div class="verdict"><b style="color:' +
                            (good ? "var(--ok)" : "var(--amb)") +
                            '">' +
                            S.lagna +
                            " lagna: " +
                            (good
                              ? "traditionally favourable."
                              : "wear only after a kundli check.") +
                            "</b>" +
                            (good
                              ? planet + " is a friendly planet for your ascendant. A short kundli check confirms it is well placed for you."
                              : gName + " is usually not a first choice here. Our specialist may suggest a better stone, and will tell you if you should not buy this one.") +
                            "</div>"
                          : "")
                      : "Which gem suits you depends on your chart. Ask a specialist about the service, pricing and suitability before ordering.") +
                    '<a target="_blank" href="' +
                    wa(
                      "Please check my kundli for " +
                        gName +
                        " (" +
                        ((v0 && v0.sku) || P.title.split(/[–-]/)[0].trim()) +
                        ")",
                    ) +
                    '" style="display:inline-flex;min-height:44px;align-items:center;font-weight:600;color:var(--ink)">Confirm with a specialist \u203A</a></div>'),
                i === 2 && (b = '<div class="qbody">Compare the listed weight, treatment, origin and report details. Ask the team for alternatives and current prices.</div>')),
              '<div class="qrow"><button class="qbtn" data-q="' +
                i +
                '" aria-expanded="' +
                open +
                '"><span class="badge ' +
                (x.ok ? "" : "q") +
                '">' +
                (x.ok ? "\u2713" : "?") +
                '</span><span class="tx"><b>' +
                x.q +
                "</b><small>" +
                esc(x.s) +
                '</small></span><span class="pm">' +
                (open ? "\u2212" : "+") +
                "</span></button>" +
                b +
                "</div>"
            );
          })
          .join("") +
        "</div>"),
      true)
    ) {
      h += quoteOnly ? '<div class="card" id="gm-cfg"><div class="hd"><span>YOUR PRODUCT OPTIONS</span><b>'+esc(quoteText("selection", "Choose your selection"))+'</b></div><div id="gm-native-purchase" class="gm-native-purchase"></div><p class="gm-service-note">'+esc(quoteText("confirmation", "Confirm the exact piece, selected options, report, price and availability with our team before ordering."))+'</p>'+quoteAction('options')+'<p data-gm-v21-status role="status" aria-live="polite"></p></div>' : '<div class="card" id="gm-cfg"><div class="hd"><span>YOUR PRODUCT OPTIONS</span><b>Choose before adding to cart</b></div><div id="gm-native-purchase" class="gm-native-purchase"></div><div class="tot"><span>PRODUCT PRICE</span><b>'+fmt(total)+'</b></div><p class="gm-service-note">Paid services and setting charges are added by the existing cart controls and calculated in cart. Delivery and eligibility are confirmed at checkout.</p>'+(inStock ? '' : '<button type="button" class="buy dark" disabled>UNAVAILABLE IN THIS SELECTION</button>')+'<p data-gm-v21-status role="status" aria-live="polite"></p></div>';
    } else
      h +=
        '<button class="buy dark" data-n="1">' +
        (S.notified
          ? "OPEN WHATSAPP AGAIN"
          : "NOTIFY ME ABOUT A SIMILAR " + gName.toUpperCase()) +
        '</button><div class="sub">' +
        (S.notified
          ? "WhatsApp opens with your request. Send it there to contact a specialist."
          : "Or choose one of the closest stones below, all in stock today.") +
        "</div>";
    ((h +=
      '<a class="sp" target="_blank" href="' +
      wa(
        "I want to talk to a gem specialist about " +
          ((v0 && v0.sku) || P.title.split(/[–-]/)[0].trim()) +
          " (" +
          weightLabel +
          " " +
          gName +
          ")",
      ) +
      '">Talk to a gem specialist on WhatsApp</a><a class="sp" style="border-color:#D4D4D0;font-weight:400" href="/pages/consultation">Or book a 1-to-1 astrology consultation \u203A</a>'),
      (h +=
        '<div class="trust"><div><b>Returns</b><a href="/policies/refund-policy">Current policy</a></div><div><b>Authenticity</b><a href="/pages/authenticity-guarantee">View guarantee</a></div><div><b>Delivery</b><a href="/policies/shipping-policy">Shipping policy</a></div></div>'),
      (h += "</div></div></div>"),
      (h += '<div class="det">'),
      similar.length &&
        (h +=
          '<span class="h" id="gm-sim">' +
          "MORE " + gName.toUpperCase() + " IN STOCK" +
          '</span><div class="sim">' +
          similar
            .map(
              (x) =>
                '<a href="/products/' +
                x.h +
                '"><div class="im">' +
                (x.img ? '<img src="' + x.img + '&width=360" alt="">' : "") +
                "</div><b>" +
                x.ct +
                " ct</b><span>" +
                fmt(x.p) +
                " \xB7 " +
                fmt(x.ppc) +
                "/ct</span></a>",
            )
            .join("") +
          "</div>"));
    if (!similar.length && simState === "done") h += '<a class="sp" href="/collections/'+(coll || "all")+'">'+esc(quoteText("browse", "Browse more "+gName+" selections"))+'</a>';
    const filmChosen = rituals[S.r].add > 0;
    ((h += '<span class="h">BEFORE YOU ORDER</span><div class="box"><div><b>Reports and included items</b><span>Confirm the exact report, packaging and any selected ritual or setting with the team before ordering.</span></div></div>'),
      (h += '<span class="h">SIZE ILLUSTRATION</span>' +
        (GI && GI.imgs[3]
          ? '<div class="size gi"><img src="' +
            GI.imgs[3] +
            '" alt="This stone next to a \u20B91 coin, drawn to scale"></div>'
          : '<div class="size">' +
            (/^\d+(?:\.\d+)?\s*×\s*\d+(?:\.\d+)?(?:\s*×\s*\d+(?:\.\d+)?)?$/.test(dims)
              ? '<div><div style="width:' +
                Math.round((num(dims) / 20) * 92) +
                "px;height:" +
                Math.round((num(dims.split(" \xD7 ")[1]) / 20) * 92) +
                "px;border-radius:36%;background:" +
                GEMBG +
                ';box-shadow:0 10px 16px -10px rgba(0,0,0,.45);margin:0 auto 8px"></div>' +
                esc(dims.split(" \xD7 ").slice(0, 2).join(" \xD7 ")) +
                ` mm</div><div><div style="width:92px;height:92px;border-radius:50%;border:1px solid #CDBB94;background:radial-gradient(circle at 35% 30%,#fff,#F1ECE1 55%,#D9CFB9);display:flex;align-items:center;justify-content:center;margin:0 auto 8px;font-family:'Playfair Display',serif;font-size:18px;color:#7E5F27">\u20B91</div>\u20B91 coin \xB7 20 mm</div>`
              : '<span style="padding:0 20px">Measurements are on the lab report. Ask on WhatsApp and we send them with a photo next to a coin.</span>') +
            "</div>")));
    const rows = [
      [
        ["Species", gName + " (" + P.type + ")"],
        ["Weight", weightDetails],
        ["Shape", shape],
        ["Dimensions", dims ? dims + " mm" : "On the report, sent on request"],
        ["Origin", origin || "Per report"],
        ["Heat / treatment", heatTxt],
        ["Specific gravity", specs["Specific Gravity"] || "Per report"],
        ["Refractive index", specs["Refractive Index"] || "Per report"],
        ["Planet", planet],
      ],
      [
        ["Laboratory", hasReport ? repLab : "One named lab, per report"],
        ["Report no.", report || "Ask the team about timing"],
        ["Report availability", "Confirm the issued report and when it will be available with the team"],
        ["Optional", "See current certificate options below; paid charges are calculated in cart"],
        ["Live video", "Ask the team about availability"],
      ],
      [
        ["Day", dayName + ", " + planet + " hora"],
        ["Finger", finger],
        ["Metal", metal],
        ["Mantra", mantra],
        ["Before", "Kundli check"],
      ],
    ];
    ((h +=
      '<span class="h">THE DETAILS</span><div class="tabs">' +
      ["Gemology", "Report", "Wearing"]
        .map(
          (x, i) =>
            '<button data-t="' +
            i +
            '" class="' +
            (i === S.tab ? "on" : "") +
            '">' +
            x +
            "</button>",
        )
        .join("") +
      '</div><div class="rows">' +
      rows[S.tab]
        .filter((x) => x[1])
        .map(
          (x) =>
            '<div class="row"><span>' +
            x[0] +
            "</span><b>" +
            esc(x[1]) +
            "</b></div>",
        )
        .join("") +
      "</div>"),
      (h += '<span class="h">CUSTOMER REVIEWS</span><div class="revs"><a class="rev" href="/pages/customer-reviews">' + (LOOX ? esc(LOOX.avg) + ' / 5 · ' + esc(LOOX.n) + ' store reviews' : 'Read customer reviews') + '</a></div>'));
  const faqs = [
      [
        "What if " + gName + " does not suit me?",
        "Ask the team about suitability before ordering. Returns and authenticity rights follow the current store policies.",
      ],
      [
        'Why "ready to wear on ' + dayName + '"?',
        gName +
          " is traditionally first worn on a " +
          dayName +
          " in " +
          planet +
          " hora. Confirm delivery and ritual timing with the team before choosing a wearing date.",
      ],
      [
        "Which ritual should I choose?",
        "Energization and ritual services follow the selected option and current shipping policy. See the available ritual options below. Choose jaap only if your astrologer advised it.",
      ],
      [
        "Can I see the stone before paying?",
        "Ask the team whether a viewing of the exact piece and its report can be arranged, and when.",
      ],
      [
        "Is the consultation free?",
        "The consultation page shows the current booking details and any applicable price.",
      ],
    ];
    ((h +=
      '<span class="h">QUESTIONS, ANSWERED</span><div class="gmfaq">' +
      faqs
        .map(
          (x, i) =>
            '<div class="qa"><button data-a="' +
            i +
            '" aria-expanded="' +
            (S.faq === i) +
            '"><span>' +
            esc(x[0]) +
            '</span><span style="color:#7E5F27;font-size:22px">' +
            (S.faq === i ? "\u2212" : "+") +
            "</span></button>" +
            (S.faq === i ? "<p>" + esc(x[1]) + "</p>" : "") +
            "</div>",
        )
        .join("") +
      "</div>"),
      (h +=
        "<div class=\"fine\"><a href='/policies/refund-policy'>Read the current returns policy</a>. Rooted in traditional Vedic belief; results may vary; not a substitute for medical, legal or financial advice.</div></div>"),
      (h = h.replace(
        /(data:image\/webp;base64,[A-Za-z0-9+\/=]+)&width=\d+/g,
        "$1",
      )),
      (root.innerHTML = h));
    const purchaseSlot = root.querySelector("#gm-native-purchase");
  purchaseSlot && purchaseSlot.appendChild(nativeHost);
  const nativeGallery = nativeHost.querySelector("product-gallery");
  if (nativeGallery && typeof nativeGallery.openLightBox === "function") {const zoom=D.createElement("button");zoom.type="button";zoom.dataset.gmZoom="1";zoom.className="gm-original-zoom";zoom.textContent="View original photo gallery";zoom.style.cssText="position:absolute;right:12px;top:12px;z-index:2;min-height:44px;padding:8px 12px;background:#fff;border:1px solid #D4D4D0";root.querySelector(".stage")?.appendChild(zoom);}
  root.querySelectorAll("button[data-v]").forEach(button => button.setAttribute("aria-pressed", String(Number(button.dataset.v) === S.view)));
  if (focused && !focused.isConnected && focused.dataset) {const key=["v","q","l","t","a"].find(k=>focused.dataset[k]!==undefined);const equivalent=key && [...root.querySelectorAll("[data-"+key+"]")].find(el=>el.dataset[key]===focused.dataset[key]);equivalent?.focus({preventScroll:true});}
  if (focused && focused.isConnected && nativeHost.contains(focused)) {focused.focus({preventScroll:true});if(selection && typeof focused.setSelectionRange === "function")try{focused.setSelectionRange(...selection);}catch(_){}}
  D.documentElement.classList.add("gm-pdp-ready");
  D.documentElement.classList.remove("gm-pdp-wait");
  if (wearBlk) {
      const ol = wearBlk.querySelector(".wear-choice .option-label");
      ol &&
        ol.childNodes.forEach((n) => {
          n.nodeType === 3 &&
            /choice of wear/i.test(n.textContent) &&
            (n.textContent = "Wear it as ");
        });
    }
    if (
      (wearBlk &&
        wearBlk
          .querySelectorAll(".design-options .design-item")
          .forEach((it) => {
            if (it.querySelector(".gm-cap")) return;
            const a = setAmt(it)
                .replace(/\s*INR/i, "")
                .trim(),
              adv = it.dataset.settingAdvance === "true",
              mc = (
                (it.querySelector(".making-charge") || {}).textContent || ""
              ).match(/\d+%/),
              c2 = D.createElement("span");
            ((c2.className = "gm-cap"),
              (c2.innerHTML =
                "<b>" +
                esc(it.dataset.value || "") +
                "</b><small>" +
                (a ? (adv ? esc(a) + " advance" : "+" + esc(a)) : "") +
                (mc ? " \xB7 +" + mc[0] + " making" : "") +
                "</small>"),
              it.appendChild(c2));
          }),
      wearBlk && !wearBlk.__open)
    ) {
      wearBlk.__open = 1;
      const ob2 = wearBlk.querySelector(".gm-opt__bar");
      ob2 && /change/i.test(ob2.textContent) && ob2.click();
    }
    const slot = D.getElementById("gm-snap");
    (slot &&
      (snapBox
        ? slot.appendChild(snapBox)
        : (slot.innerHTML =
            '<div class="sub">Payment options and eligibility are confirmed at checkout.</div>')),
      (sticky.innerHTML =
        '<div class="p"><b>' +
        (quoteOnly ? esc(quoteLabel) : fmt(inStock ? total : base)) +
        "</b><span>" +
        (quoteOnly ? "Confirm your selection with our team" : inStock
          ? "Product price · paid extras calculated in cart"
          : "Unavailable in this selection") +
        '</span></div><a target="_blank" href="' +
        wa(
          "Question about " +
            ((v0 && v0.sku) || P.title.split(/[–-]/)[0].trim()) +
            " (" +
            weightLabel +
            " " +
            gName +
            ")",
        ) +
        '" aria-label="Ask on WhatsApp"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#111113" stroke-width="1.5"><path d="M4 20l1.3-4A8 8 0 1 1 8 18.7z"/></svg></a><button ' +
        (inStock ? 'data-buy="1" ' : "") +
        'style="background:' +
        (inStock ? "#5C0E1B" : "#12151D") +
        '">' +
        (inStock
          ? BOOK
            ? "BOOK NOW"
            : "BUY NOW"
          : S.notified
            ? "OPEN WHATSAPP AGAIN"
            : "NOTIFY ME") +
        "</button>"));
    if (quoteOnly) sticky.innerHTML = '<div class="p"><b>'+esc(quoteLabel)+'</b><span>'+esc(quoteText("short", "Confirm price and availability"))+'</span></div>'+quoteAction('sticky');
    // In stock: sticky bar = thumbnail + title + price + Add to cart + Buy Now (as on the live theme).
    // Both buttons forward to the hero pair above (sticky.onclick), so cart rules stay in one place.
    sticky.classList.remove("gm-has-off");
    if (!quoteOnly && inStock && !BOOK && W.GM_PDP_STICKY_OFFER) sticky.classList.add("gm-has-off");
    if (!quoteOnly && inStock && !BOOK) sticky.innerHTML =
      (W.GM_PDP_STICKY_OFFER ? '<div class="gm-off">' + esc(W.GM_PDP_STICKY_OFFER) + "</div>" : "") +
      (media && media[0] ? '<img class="th" src="' + esc(media[0]) + '" alt="" width="48" height="48" decoding="async">' : "") +
      '<div class="p"><span class="tt">' + esc(P.title) + "</span><b>" + fmt(total) + "</b></div>" +
      '<button type="button" class="gm-ghost" data-buy="1">ADD TO CART</button><button type="button" class="gm-bn" data-buynow="1">BUY NOW</button>';
    if (W.__gmStickySync) W.__gmStickySync();
    if (quoteOnly && focused?.classList.contains("gm-quote-enquiry") && !focused.isConnected && focused.id) D.getElementById(focused.id)?.focus({preventScroll:true});
  }
  const releaseBuyPress = () => {
    buyPress = null;
    if(disposed || simState !== "done")return;
    const timer=setTimeout(()=>{renderTimers.delete(timer);if(!disposed)simApply();},0);
    renderTimers.add(timer);
  };
  const pointerId = e => e.pointerId ?? 0;
  listen(D,"pointerdown",e=>{
    if(disposed || e.isPrimary === false)return;
    const id=pointerId(e);
    if(buyPress && !buyPress.released && buyPress.id !== id)return;
    const b=e.target.closest?.("[data-buy],[data-buynow],.gm-quote-enquiry");
    if(b && (root.contains(b) || sticky.contains(b)) && (e.button == null || e.button === 0))buyPress={id,target:b,released:false};
    else if(buyPress)releaseBuyPress();
  },true);
  listen(D,"pointerup",e=>{if(!buyPress || buyPress.id !== pointerId(e))return;buyPress.released=true;if(!buyPress.target.contains(e.target))releaseBuyPress();},true);
  listen(D,"pointercancel",e=>{if(buyPress && buyPress.id === pointerId(e))releaseBuyPress();},true);
  listen(D,"lostpointercapture",e=>{if(buyPress && buyPress.id === pointerId(e) && !buyPress.released)releaseBuyPress();},true);
  listen(W,"blur",()=>{if(buyPress)releaseBuyPress();});
  listen(D,"click",e=>{if(buyPress && (buyPress.target.contains(e.target) || buyPress.released))releaseBuyPress();});
  listen(root,"focusout",()=>{const timer=setTimeout(()=>{renderTimers.delete(timer);if(!disposed && simState === "done")simApply();},0);renderTimers.add(timer);});
  listen(D,"click",event=>{
    const link=event.target.closest?.(".gm-quote-enquiry");
    if(!link || !quoteOnly || !(root.contains(link) || sticky.contains(link)))return;
    const selected=variantById(nativeId());
    if(disposed || !quoteFormOwned(pform) || !selected || String(selected.id)!==link.dataset.gmVariantId || pform.dataset.gmVariantPending === "true" || pform.dataset.gmSubmitting === "true" || pform.dataset.gmVariantInvalid === "true" || link.getAttribute("aria-disabled") === "true")event.preventDefault();
  },true);
  const nativeChanged = () => { if(disposed)return;adoptNative(); if (nativeHost && nativeHost.isConnected && !keep.contains(nativeHost)) render(); };
  listen(main,"change", e => {const t=e.target;if(!t.closest(".gm-native-purchase"))return;const textual=t.tagName==="TEXTAREA" || t.tagName==="INPUT" && ["text","email","tel","search","url"].includes(t.type);if(textual && /^properties\[/.test(t.name || ""))return;queueMicrotask(nativeChanged);});
  listen(D,"variant:change", e => {if(e.target === pform || e.target?.getAttribute("id") === nativeFormId) queueMicrotask(nativeChanged);});
  listen(D,"product:rerender", e => {if(e.target === pform || e.target?.getAttribute("id") === nativeFormId) {if(e.detail?.productChange) queueMicrotask(()=>{if(disposed)return;nativeHost=(nativeHostId && D.getElementById(nativeHostId)) || root.querySelector("product-rerender") || nativeHost;rollback();});else queueMicrotask(nativeChanged);}},true);
  nativeObserver = new MutationObserver(() => queueMicrotask(nativeChanged));
  nativeObserver.observe(main,{subtree:true,attributes:true,attributeFilter:["data-gm-variant-pending","data-gm-variant-invalid","data-gm-submitting"]});
  listen(main,"cart:error", e => {const status=root.querySelector("[data-gm-v21-status]");if(status)status.textContent=e.detail?.error || "Review your options before trying again.";});
  listen(main,"variant:add", () => {const status=root.querySelector("[data-gm-v21-status]");if(status)status.textContent="Added to cart.";});
  return (
    root.addEventListener("click", (e) => {
      if (disposed) return;
      const b = e.target.closest("button,a");
      if (!b) return;
      b.tagName === "A" && b.getAttribute("href") === "#" && e.preventDefault();
      const d = b.dataset;
      if (quoteOnly && (d.buy || d.buynow || d.n)) {e.preventDefault();return;}
      if (d.gmZoom) {const gallery=nativeHost.querySelector("product-gallery");gallery?.openLightBox();return;}
      if (d.w) S.w = +d.w;
      else if (d.v) S.view = +d.v;
      else if (d.q) S.q = S.q === +d.q ? -1 : +d.q;
      else if (d.l) S.lagna = d.l;
      else if (d.r) S.r = +d.r;
      else if (d.custom) S.custom = !S.custom;
      else if (d.c) S.c = +d.c;
      else if (d.f) S.f = +d.f;
      else if (d.s) S.sat = +d.s;
      else if (d.t) S.tab = +d.t;
      else if (d.a) S.faq = S.faq === +d.a ? -1 : +d.a;
      else if (d.n) S.notified = !0;
      else if (d.buy || d.buynow) {
        if (!wearOK()) {
          const t = D.getElementById("gm-wear");
          t &&
            (t.scrollIntoView({ behavior: "smooth", block: "center" }),
            t.classList.add("gm-need"),
            setTimeout(() => t.classList.remove("gm-need"), 2500));
          return;
        }
        adoptNative();
      const vi = variantById(nativeId()), status=root.querySelector("[data-gm-v21-status]");
      if (!vi || !vi.available || !pform?.isConnected || pform.dataset.gmVariantPending === "true" || pform.dataset.gmVariantInvalid === "true" || !atcBtn || atcBtn.disabled || atcBtn.getAttribute("aria-disabled") === "true" || atcBtn.getAttribute("aria-busy") === "true") {if(status)status.textContent="This selection cannot be added. Review the product options.";return;}
      const paidChoice=nativeHost.querySelector('.np-pe input[data-variant-id]:checked,.np-cert option[data-kind="cert"]:checked');
      if(paidChoice && (!W.gmPurchase || typeof W.gmPurchase.begin !== "function")){if(status)status.textContent="Paid service checkout is unavailable. Clear the paid selection or contact the team.";return;}
      if (d.buynow) {
        // Buy Now: the theme's own [data-gem-buy-now] handler adds this stone (+ chosen paid services) through the
        // same purchase coordinator as Add to cart, then opens checkout. It sits next to the native Add to cart button.
        const nativeBuyNow = nativeHost.querySelector("[data-gem-buy-now]");
        if (!nativeBuyNow || nativeBuyNow.disabled) {if(status)status.textContent="Buy Now is not available for this selection. Use Add to cart.";return;}
        nativeBuyNow.click();
        return;
      }
      atcBtn.click();
        return;
      } else return;
      render();
    }),
    (sticky.onclick = (e) => {
      if (disposed) return;
      (e.target.closest("[data-buynow]")
        ? root.querySelector("[data-buynow]")?.click()
        : e.target.closest("[data-buy]") &&
          root.querySelector("[data-buy]")?.click());
    }),
    render(),
    simLoad(),
    (W.__GMV2 = {
      handle,
      specs: Object.keys(specs).length,
      similar: similar.length,
      hasReport,
      inStock,
      high,
      imgs: media.length,
    }),
    JSON.stringify(W.__GMV2)
  );
})().catch(function(error){window.__gmV21Rollback?.();document.documentElement.classList.remove("gm-pdp-wait","gm-pdp-ready");console.warn("GemsMantra product layout could not initialize; native purchase controls retained.");})
//# sourceMappingURL=/cdn/shop/t/248/assets/gm-pdp-v21.js.map?v=171613093234448061731791505362

;/* Sticky bar: show it only while the hero Add to cart / Buy Now pair is off screen (desktop and mobile), like the live theme's sticky bar. */
(function () {
  if (window.__gmStickySyncInit) return;
  window.__gmStickySyncInit = 1;
  var D = document, W = window, html = D.documentElement, queued = false;
  function sync() {
    queued = false;
    try {
      var show = true;
      if (!D.querySelector(".gmv2-sticky") || !html.classList.contains("gm-pdp-ready")) { html.classList.remove("gm-sb"); return; }
      var hero = D.querySelector("#gmv2 .qb [data-buy],#gmv2 .qb [data-buynow]");
      if (hero && hero.getClientRects().length) { // on phones the hero row is hidden by the layout: the bar stays up
        var r = hero.getBoundingClientRect();
        show = r.bottom <= 0 || r.top >= W.innerHeight;
      }
      html.classList.toggle("gm-sb", show);
    } catch (e) { html.classList.add("gm-sb"); }
  }
  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(sync, 16); // not requestAnimationFrame: it pauses in background tabs
  }
  W.__gmStickySync = queue;
  W.addEventListener("scroll", queue, { passive: true });
  W.addEventListener("resize", queue);
  W.addEventListener("load", queue);
})();
